var _rect, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _rect2, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 695,
    viewBox: "0 0 1440 695",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_131_104)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 695,
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_131_104",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 1529,
    height: 789
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.121 563.399C606.126 563.944 606.293 564.475 606.6 564.926C606.907 565.376 607.34 565.726 607.846 565.93C608.352 566.134 608.906 566.183 609.44 566.071C609.974 565.96 610.462 565.692 610.844 565.303C611.226 564.914 611.483 564.42 611.584 563.884C611.685 563.349 611.625 562.795 611.411 562.293C611.197 561.792 610.839 561.365 610.383 561.067C609.926 560.769 609.391 560.613 608.846 560.619C608.117 560.627 607.42 560.924 606.909 561.446C606.398 561.967 606.115 562.669 606.121 563.399Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M652.784 598.829C667.442 584.171 667.437 560.399 652.771 545.733C638.105 531.067 614.333 531.062 599.675 545.72C585.016 560.379 585.022 584.151 599.688 598.816C614.353 613.482 638.125 613.488 652.784 598.829ZM601.813 579.694C601.813 583.942 604.914 587.389 608.737 587.389C612.56 587.389 615.656 583.948 615.656 579.694V563.496C615.656 559.248 612.554 555.807 608.737 555.807C604.92 555.807 601.813 559.248 601.813 563.496V579.694ZM629.565 587.449H620.08V556.438H629.638V560.686C633.079 555.88 639.014 555.879 641.114 556.262C650.879 557.991 650.788 568.187 650.788 568.187V587.449H641.321V571.865C641.509 565.899 639.409 564.364 635.385 563.975C628.88 564.746 629.565 570.76 629.565 570.76V587.449Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M941.896 280.086C955.781 293.971 955.786 316.477 941.909 330.354C928.032 344.231 905.526 344.226 891.641 330.341C877.756 316.456 877.751 293.95 891.628 280.073C905.505 266.196 928.011 266.201 941.896 280.086Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.661 296.337C896.665 296.883 896.832 297.414 897.139 297.865C897.446 298.315 897.88 298.664 898.385 298.868C898.891 299.072 899.446 299.122 899.979 299.01C900.513 298.898 901.002 298.631 901.383 298.242C901.765 297.853 902.022 297.359 902.123 296.823C902.224 296.287 902.164 295.734 901.95 295.232C901.736 294.731 901.378 294.304 900.922 294.006C900.465 293.708 899.931 293.552 899.385 293.558C898.656 293.566 897.959 293.863 897.448 294.384C896.937 294.905 896.654 295.608 896.661 296.337Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.352 312.632C892.352 316.88 895.453 320.327 899.276 320.327C903.1 320.327 906.195 316.886 906.195 312.632V296.434C906.195 292.186 903.094 288.745 899.276 288.745C895.459 288.745 892.352 292.186 892.352 296.434V312.632Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.619 320.388H920.104V303.699C920.104 303.699 919.419 297.685 925.924 296.914C929.948 297.302 932.048 298.838 931.86 304.803C931.86 309.998 931.86 320.388 931.86 320.388H941.327V301.126C941.327 301.126 941.418 290.93 931.653 289.2C929.554 288.818 923.618 288.818 920.177 293.625V289.377H910.619V320.388Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M651.357 636.168C665.242 650.053 665.247 672.559 651.37 686.436C637.493 700.313 614.987 700.308 601.102 686.423C587.216 672.538 587.212 650.032 601.089 636.155C614.966 622.278 637.471 622.283 651.357 636.168Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.121 652.419C606.126 652.965 606.293 653.496 606.6 653.947C606.907 654.397 607.34 654.746 607.846 654.95C608.352 655.154 608.906 655.203 609.44 655.092C609.974 654.98 610.462 654.713 610.844 654.324C611.226 653.934 611.483 653.441 611.584 652.905C611.685 652.369 611.625 651.815 611.411 651.314C611.197 650.813 610.839 650.386 610.383 650.088C609.926 649.79 609.391 649.634 608.846 649.64C608.117 649.648 607.42 649.945 606.909 650.466C606.398 650.987 606.115 651.69 606.121 652.419Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.813 668.714C601.813 672.962 604.914 676.409 608.737 676.409C612.56 676.409 615.656 672.968 615.656 668.714V652.516C615.656 648.268 612.554 644.827 608.737 644.827C604.92 644.827 601.813 648.268 601.813 652.516V668.714Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.08 676.47H629.565V659.781C629.565 659.781 628.879 653.767 635.385 652.996C639.409 653.384 641.509 654.92 641.321 660.885C641.321 666.08 641.321 676.47 641.321 676.47H650.788V657.208C650.788 657.208 650.879 647.012 641.114 645.282C639.014 644.9 633.079 644.9 629.638 649.707V645.458H620.08V676.47Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M993.507 207.317C993.512 207.862 993.678 208.394 993.985 208.844C994.292 209.295 994.726 209.644 995.232 209.848C995.737 210.052 996.292 210.101 996.826 209.99C997.359 209.878 997.848 209.611 998.23 209.221C998.611 208.832 998.869 208.338 998.97 207.803C999.071 207.267 999.01 206.713 998.797 206.212C998.583 205.71 998.225 205.283 997.768 204.985C997.312 204.687 996.777 204.532 996.232 204.538C995.502 204.546 994.806 204.843 994.295 205.364C993.784 205.885 993.501 206.587 993.507 207.317Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1040.17 242.748C1054.83 228.089 1054.82 204.317 1040.16 189.651C1025.49 174.986 1001.72 174.98 987.06 189.638C972.402 204.297 972.407 228.069 987.073 242.735C1001.74 257.4 1025.51 257.406 1040.17 242.748ZM989.198 223.612C989.198 227.86 992.299 231.307 996.123 231.307C999.946 231.307 1003.04 227.866 1003.04 223.612V207.414C1003.04 203.166 999.94 199.725 996.123 199.725C992.305 199.725 989.198 203.166 989.198 207.414V223.612ZM1016.95 231.368H1007.47V200.356H1017.02V204.604C1020.46 199.798 1026.4 199.798 1028.5 200.18C1038.26 201.91 1038.17 212.105 1038.17 212.105V231.368H1028.71V215.783C1028.89 209.817 1026.79 208.282 1022.77 207.893C1016.27 208.664 1016.95 214.678 1016.95 214.678V231.368Z",
    fill: "#C4C4C4"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M702.968 296.337C702.972 296.883 703.139 297.414 703.446 297.865C703.753 298.315 704.187 298.664 704.692 298.868C705.198 299.072 705.753 299.122 706.286 299.01C706.82 298.898 707.309 298.631 707.69 298.242C708.072 297.853 708.33 297.359 708.43 296.823C708.531 296.287 708.471 295.734 708.257 295.232C708.043 294.731 707.685 294.304 707.229 294.006C706.772 293.708 706.238 293.552 705.693 293.558C704.963 293.566 704.266 293.863 703.755 294.384C703.244 294.905 702.961 295.608 702.968 296.337Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M749.63 331.768C764.289 317.109 764.283 293.337 749.617 278.672C734.951 264.006 711.179 264 696.521 278.659C681.862 293.317 681.868 317.089 696.534 331.755C711.199 346.421 734.971 346.426 749.63 331.768ZM698.659 312.632C698.659 316.88 701.76 320.327 705.583 320.327C709.407 320.327 712.502 316.886 712.502 312.632V296.434C712.502 292.186 709.401 288.745 705.583 288.745C701.766 288.745 698.659 292.186 698.659 296.434V312.632ZM726.412 320.388H716.926V289.376H726.484V293.625C729.925 288.818 735.861 288.818 737.96 289.2C747.725 290.93 747.634 301.126 747.634 301.126V320.388H738.167V304.803C738.355 298.838 736.255 297.302 732.232 296.914C725.726 297.685 726.412 303.699 726.412 303.699V320.388Z",
    fill: "#C4C4C4"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M509.275 474.378C509.28 474.923 509.446 475.455 509.753 475.905C510.06 476.356 510.494 476.705 511 476.909C511.505 477.113 512.06 477.162 512.594 477.051C513.127 476.939 513.616 476.672 513.998 476.283C514.379 475.893 514.637 475.4 514.738 474.864C514.839 474.328 514.778 473.774 514.564 473.273C514.351 472.771 513.993 472.345 513.536 472.047C513.08 471.749 512.545 471.593 512 471.599C511.27 471.607 510.573 471.904 510.063 472.425C509.552 472.946 509.268 473.649 509.275 474.378Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.937 509.809C570.596 495.15 570.59 471.378 555.924 456.713C541.259 442.047 517.487 442.041 502.828 456.7C488.17 471.358 488.175 495.13 502.841 509.796C517.507 524.462 541.279 524.467 555.937 509.809ZM504.966 490.673C504.966 494.921 508.067 498.368 511.891 498.368C515.714 498.368 518.809 494.927 518.809 490.673V474.475C518.809 470.227 515.708 466.786 511.891 466.786C508.073 466.786 504.966 470.227 504.966 474.475V490.673ZM532.719 498.429H523.233V467.417H532.792V471.666C536.233 466.859 542.168 466.859 544.268 467.241C554.033 468.971 553.941 479.167 553.941 479.167V498.429H544.474V482.844C544.662 476.879 542.562 475.343 538.539 474.955C532.033 475.726 532.719 481.74 532.719 481.74V498.429Z",
    fill: "#C4C4C4"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M509.275 207.317C509.28 207.862 509.446 208.394 509.753 208.844C510.06 209.295 510.494 209.644 511 209.848C511.505 210.052 512.06 210.101 512.594 209.99C513.127 209.878 513.616 209.611 513.998 209.221C514.379 208.832 514.637 208.338 514.738 207.803C514.839 207.267 514.778 206.713 514.564 206.212C514.351 205.71 513.993 205.283 513.536 204.985C513.08 204.687 512.545 204.532 512 204.538C511.27 204.546 510.573 204.843 510.063 205.364C509.552 205.885 509.268 206.587 509.275 207.317Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.937 242.748C570.596 228.089 570.59 204.317 555.924 189.651C541.259 174.986 517.487 174.98 502.828 189.638C488.17 204.297 488.175 228.069 502.841 242.735C517.507 257.4 541.279 257.406 555.937 242.748ZM504.966 223.612C504.966 227.86 508.067 231.307 511.891 231.307C515.714 231.307 518.809 227.866 518.809 223.612V207.414C518.809 203.166 515.708 199.725 511.891 199.725C508.073 199.725 504.966 203.166 504.966 207.414V223.612ZM532.719 231.368H523.233V200.356H532.792V204.604C536.233 199.798 542.168 199.798 544.268 200.18C554.033 201.91 553.941 212.105 553.941 212.105V231.368H544.474V215.783C544.662 209.817 542.562 208.282 538.539 207.893C532.033 208.664 532.719 214.678 532.719 214.678V231.368Z",
    fill: "#C4C4C4"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.817 102.045C374.703 115.93 374.707 138.436 360.83 152.313C346.953 166.19 324.448 166.185 310.562 152.3C296.677 138.415 296.673 115.909 310.55 102.032C324.426 88.1552 346.932 88.1596 360.817 102.045Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.582 118.296C315.587 118.842 315.753 119.373 316.06 119.824C316.367 120.274 316.801 120.623 317.307 120.827C317.812 121.031 318.367 121.08 318.901 120.969C319.434 120.857 319.923 120.59 320.305 120.201C320.686 119.812 320.944 119.318 321.045 118.782C321.146 118.246 321.085 117.693 320.872 117.191C320.658 116.69 320.3 116.263 319.843 115.965C319.387 115.667 318.852 115.511 318.307 115.517C317.577 115.525 316.881 115.822 316.37 116.343C315.859 116.864 315.576 117.567 315.582 118.296Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.273 134.591C311.273 138.839 314.374 142.286 318.198 142.286C322.021 142.286 325.116 138.845 325.116 134.591V118.393C325.116 114.145 322.015 110.704 318.198 110.704C314.38 110.704 311.273 114.145 311.273 118.393V134.591Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.54 142.347H339.026V125.658C339.026 125.658 338.34 119.644 344.846 118.873C348.869 119.261 350.969 120.797 350.781 126.762C350.781 131.957 350.781 142.347 350.781 142.347H360.249V123.085C360.249 123.085 360.34 112.889 350.575 111.159C348.475 110.777 342.54 110.777 339.099 115.584V111.335H329.54V142.347Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.582 29.276C315.587 29.8212 315.753 30.3527 316.06 30.8032C316.367 31.2537 316.801 31.603 317.307 31.8069C317.812 32.0108 318.367 32.0601 318.901 31.9486C319.434 31.8371 319.923 31.5697 320.305 31.1804C320.686 30.7911 320.944 30.2973 321.045 29.7616C321.146 29.2258 321.085 28.6722 320.872 28.1707C320.658 27.6692 320.3 27.2425 319.843 26.9444C319.387 26.6464 318.852 26.4905 318.307 26.4965C317.577 26.5045 316.881 26.8017 316.37 27.3228C315.859 27.8439 315.576 28.5463 315.582 29.276Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.244 64.7065C376.903 50.0479 376.897 26.2759 362.232 11.6102C347.566 -3.05547 323.794 -3.06124 309.135 11.5973C294.477 26.2559 294.482 50.0279 309.148 64.6936C323.814 79.3593 347.586 79.3651 362.244 64.7065ZM311.273 45.5707C311.273 49.8188 314.374 53.2659 318.198 53.2659C322.021 53.2659 325.116 49.8249 325.116 45.5707V29.373C325.116 25.1248 322.015 21.6838 318.198 21.6838C314.38 21.6838 311.273 25.1248 311.273 29.373V45.5707ZM339.026 53.3266H329.54V22.315H339.099V26.5632C342.54 21.7567 348.475 21.7566 350.575 22.139C360.34 23.8686 360.249 34.0642 360.249 34.0642V53.3266H350.781V37.7419C350.969 31.7763 348.87 30.2409 344.846 29.8524C338.34 30.6232 339.026 36.6374 339.026 36.6374V53.3266Z",
    fill: "#C4C4C4"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.664 458.127C471.549 472.012 471.553 494.518 457.676 508.395C443.8 522.272 421.294 522.267 407.409 508.382C393.523 494.496 393.519 471.991 407.396 458.114C421.273 444.237 443.778 444.241 457.664 458.127Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.428 474.378C412.433 474.923 412.6 475.455 412.907 475.905C413.214 476.356 413.647 476.705 414.153 476.909C414.659 477.113 415.213 477.162 415.747 477.051C416.281 476.939 416.769 476.672 417.151 476.283C417.532 475.893 417.79 475.4 417.891 474.864C417.992 474.328 417.932 473.774 417.718 473.273C417.504 472.771 417.146 472.345 416.689 472.047C416.233 471.749 415.698 471.593 415.153 471.599C414.423 471.607 413.727 471.904 413.216 472.425C412.705 472.946 412.422 473.649 412.428 474.378Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.119 490.673C408.119 494.921 411.22 498.368 415.044 498.368C418.867 498.368 421.962 494.927 421.962 490.673V474.475C421.962 470.227 418.861 466.786 415.044 466.786C411.227 466.786 408.119 470.227 408.119 474.475V490.673Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.387 498.429H435.872V481.74C435.872 481.74 435.186 475.726 441.692 474.955C445.716 475.343 447.816 476.879 447.627 482.844C447.627 488.039 447.627 498.429 447.627 498.429H457.095V479.167C457.095 479.167 457.186 468.971 447.421 467.241C445.321 466.859 439.386 466.859 435.945 471.666V467.417H426.387V498.429Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.278 369.107C84.1633 382.992 84.1677 405.498 70.2909 419.374C56.414 433.251 33.9083 433.247 20.023 419.362C6.13771 405.476 6.13323 382.971 20.0101 369.094C33.887 355.217 56.3927 355.221 70.278 369.107Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0426 385.358C25.0474 385.903 25.2139 386.435 25.5209 386.885C25.8279 387.336 26.2617 387.685 26.7673 387.889C27.2729 388.093 27.8277 388.142 28.3613 388.031C28.895 387.919 29.3836 387.652 29.7652 387.262C30.1469 386.873 30.4045 386.379 30.5054 385.844C30.6063 385.308 30.546 384.754 30.3321 384.253C30.1182 383.751 29.7604 383.324 29.3038 383.026C28.8473 382.728 28.3126 382.573 27.7675 382.579C27.0378 382.587 26.3411 382.884 25.8302 383.405C25.3194 383.926 25.0361 384.628 25.0426 385.358Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7337 401.653C20.7337 405.901 23.8349 409.348 27.6582 409.348C31.4816 409.348 34.5767 405.907 34.5767 401.653V385.455C34.5767 381.207 31.4755 377.766 27.6582 377.766C23.8409 377.766 20.7337 381.207 20.7337 385.455V401.653Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0009 409.409H48.4864V392.719C48.4864 392.719 47.8006 386.705 54.3064 385.934C58.33 386.323 60.4299 387.858 60.2417 393.824C60.2417 399.019 60.2417 409.409 60.2417 409.409H69.7091V390.146C69.7091 390.146 69.8001 379.951 60.0354 378.221C57.9356 377.839 52.0003 377.839 48.5592 382.645V378.397H39.0009V409.409Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.971 13.0245C277.856 26.9098 277.861 49.4155 263.984 63.2924C250.107 77.1693 227.601 77.1648 213.716 63.2795C199.831 49.3942 199.826 26.8886 213.703 13.0117C227.58 -0.865213 250.086 -0.860742 263.971 13.0245Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.736 29.276C218.74 29.8212 218.907 30.3527 219.214 30.8032C219.521 31.2537 219.955 31.603 220.46 31.8069C220.966 32.0108 221.521 32.0601 222.054 31.9486C222.588 31.8371 223.076 31.5697 223.458 31.1804C223.84 30.7911 224.097 30.2973 224.198 29.7616C224.299 29.2258 224.239 28.6722 224.025 28.1707C223.811 27.6692 223.453 27.2425 222.997 26.9444C222.54 26.6464 222.006 26.4905 221.46 26.4965C220.731 26.5045 220.034 26.8017 219.523 27.3228C219.012 27.8439 218.729 28.5463 218.736 29.276Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.427 45.5707C214.427 49.8189 217.528 53.266 221.351 53.266C225.175 53.266 228.27 49.8249 228.27 45.5707V29.3731C228.27 25.1249 225.168 21.6838 221.351 21.6838C217.534 21.6838 214.427 25.1249 214.427 29.3731V45.5707Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.694 53.3266H242.179V36.6374C242.179 36.6374 241.494 30.6232 247.999 29.8525C252.023 30.2409 254.123 31.7763 253.935 37.7419C253.935 42.9368 253.935 53.3266 253.935 53.3266H263.402V34.0642C263.402 34.0642 263.493 23.8686 253.728 22.139C251.629 21.7566 245.693 21.7567 242.252 26.5632V22.315H232.694V53.3266Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1135.59 369.107C1149.47 382.992 1149.48 405.498 1135.6 419.374C1121.72 433.251 1099.22 433.247 1085.33 419.362C1071.45 405.476 1071.44 382.971 1085.32 369.094C1099.2 355.217 1121.7 355.221 1135.59 369.107Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090.35 385.358C1090.36 385.903 1090.52 386.435 1090.83 386.885C1091.14 387.336 1091.57 387.685 1092.08 387.889C1092.58 388.093 1093.14 388.142 1093.67 388.031C1094.21 387.919 1094.69 387.652 1095.08 387.262C1095.46 386.873 1095.72 386.379 1095.82 385.844C1095.92 385.308 1095.86 384.754 1095.64 384.253C1095.43 383.751 1095.07 383.324 1094.61 383.026C1094.16 382.728 1093.62 382.573 1093.08 382.579C1092.35 382.587 1091.65 382.884 1091.14 383.405C1090.63 383.926 1090.35 384.628 1090.35 385.358Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.04 401.653C1086.04 405.901 1089.15 409.348 1092.97 409.348C1096.79 409.348 1099.89 405.907 1099.89 401.653V385.455C1099.89 381.207 1096.79 377.766 1092.97 377.766C1089.15 377.766 1086.04 381.207 1086.04 385.455V401.653Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104.31 409.409H1113.8V392.719C1113.8 392.719 1113.11 386.705 1119.62 385.934C1123.64 386.323 1125.74 387.858 1125.55 393.824C1125.55 399.019 1125.55 409.409 1125.55 409.409H1135.02V390.146C1135.02 390.146 1135.11 379.951 1125.35 378.221C1123.25 377.839 1117.31 377.839 1113.87 382.645V378.397H1104.31V409.409Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1232.44 191.066C1246.32 204.951 1246.33 227.457 1232.45 241.333C1218.57 255.21 1196.07 255.206 1182.18 241.321C1168.3 227.435 1168.29 204.93 1182.17 191.053C1196.04 177.176 1218.55 177.18 1232.44 191.066Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187.2 207.317C1187.2 207.862 1187.37 208.394 1187.68 208.844C1187.99 209.295 1188.42 209.644 1188.92 209.848C1189.43 210.052 1189.99 210.101 1190.52 209.99C1191.05 209.878 1191.54 209.611 1191.92 209.221C1192.3 208.832 1192.56 208.338 1192.66 207.803C1192.76 207.267 1192.7 206.713 1192.49 206.212C1192.28 205.71 1191.92 205.283 1191.46 204.985C1191 204.687 1190.47 204.532 1189.92 204.538C1189.2 204.546 1188.5 204.843 1187.99 205.364C1187.48 205.885 1187.19 206.587 1187.2 207.317Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1182.89 223.612C1182.89 227.86 1185.99 231.307 1189.82 231.307C1193.64 231.307 1196.73 227.866 1196.73 223.612V207.414C1196.73 203.166 1193.63 199.725 1189.82 199.725C1186 199.725 1182.89 203.166 1182.89 207.414V223.612Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.16 231.368H1210.64V214.678C1210.64 214.678 1209.96 208.664 1216.46 207.893C1220.49 208.282 1222.59 209.817 1222.4 215.783C1222.4 220.978 1222.4 231.368 1222.4 231.368H1231.87V212.105C1231.87 212.105 1231.96 201.91 1222.19 200.18C1220.09 199.798 1214.16 199.798 1210.72 204.604V200.356H1201.16V231.368Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip15_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M941.896 191.066C955.781 204.951 955.786 227.457 941.909 241.333C928.032 255.21 905.526 255.206 891.641 241.321C877.756 227.435 877.751 204.93 891.628 191.053C905.505 177.176 928.011 177.18 941.896 191.066Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.661 207.317C896.665 207.862 896.832 208.394 897.139 208.844C897.446 209.295 897.88 209.644 898.385 209.848C898.891 210.052 899.446 210.101 899.979 209.99C900.513 209.878 901.002 209.611 901.383 209.221C901.765 208.832 902.022 208.338 902.123 207.803C902.224 207.267 902.164 206.713 901.95 206.212C901.736 205.71 901.378 205.283 900.922 204.985C900.465 204.687 899.931 204.532 899.385 204.538C898.656 204.546 897.959 204.843 897.448 205.364C896.937 205.885 896.654 206.587 896.661 207.317Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.352 223.612C892.352 227.86 895.453 231.307 899.276 231.307C903.1 231.307 906.195 227.866 906.195 223.612V207.414C906.195 203.166 903.094 199.725 899.276 199.725C895.459 199.725 892.352 203.166 892.352 207.414V223.612Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.619 231.368H920.104V214.678C920.104 214.678 919.419 208.664 925.924 207.893C929.948 208.282 932.048 209.817 931.86 215.783C931.86 220.978 931.86 231.368 931.86 231.368H941.327V212.105C941.327 212.105 941.418 201.91 931.653 200.18C929.554 199.798 923.618 199.798 920.177 204.604V200.356H910.619V231.368Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip16_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M845.05 280.086C858.935 293.971 858.939 316.477 845.062 330.354C831.186 344.231 808.68 344.226 794.795 330.341C780.909 316.456 780.905 293.95 794.782 280.073C808.659 266.196 831.164 266.201 845.05 280.086Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.814 296.337C799.819 296.883 799.985 297.414 800.293 297.865C800.6 298.315 801.033 298.664 801.539 298.868C802.045 299.072 802.599 299.122 803.133 299.01C803.667 298.898 804.155 298.631 804.537 298.242C804.918 297.853 805.176 297.359 805.277 296.823C805.378 296.287 805.318 295.734 805.104 295.232C804.89 294.731 804.532 294.304 804.075 294.006C803.619 293.708 803.084 293.552 802.539 293.558C801.809 293.566 801.113 293.863 800.602 294.384C800.091 294.905 799.808 295.608 799.814 296.337Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.505 312.632C795.505 316.88 798.607 320.327 802.43 320.327C806.253 320.327 809.348 316.886 809.348 312.632V296.434C809.348 292.186 806.247 288.745 802.43 288.745C798.613 288.745 795.505 292.186 795.505 296.434V312.632Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.772 320.388H823.258V303.699C823.258 303.699 822.572 297.685 829.078 296.914C833.102 297.302 835.201 298.838 835.013 304.803C835.013 309.998 835.013 320.388 835.013 320.388H844.481V301.126C844.481 301.126 844.572 290.93 834.807 289.2C832.707 288.818 826.772 288.818 823.331 293.625V289.377H813.772V320.388Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip17_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M845.05 191.066C858.935 204.951 858.939 227.457 845.062 241.333C831.186 255.21 808.68 255.206 794.795 241.321C780.909 227.435 780.905 204.93 794.782 191.053C808.659 177.176 831.164 177.18 845.05 191.066Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.814 207.317C799.819 207.862 799.985 208.394 800.293 208.844C800.6 209.295 801.033 209.644 801.539 209.848C802.045 210.052 802.599 210.101 803.133 209.99C803.667 209.878 804.155 209.611 804.537 209.221C804.918 208.832 805.176 208.338 805.277 207.803C805.378 207.267 805.318 206.713 805.104 206.212C804.89 205.71 804.532 205.283 804.075 204.985C803.619 204.687 803.084 204.532 802.539 204.538C801.809 204.546 801.113 204.843 800.602 205.364C800.091 205.885 799.808 206.587 799.814 207.317Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.505 223.612C795.505 227.86 798.607 231.307 802.43 231.307C806.253 231.307 809.348 227.866 809.348 223.612V207.414C809.348 203.166 806.247 199.725 802.43 199.725C798.613 199.725 795.505 203.166 795.505 207.414V223.612Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.772 231.368H823.258V214.678C823.258 214.678 822.572 208.664 829.078 207.893C833.102 208.282 835.201 209.817 835.013 215.783C835.013 220.978 835.013 231.368 835.013 231.368H844.481V212.105C844.481 212.105 844.572 201.91 834.807 200.18C832.707 199.798 826.772 199.798 823.331 204.604V200.356H813.772V231.368Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip18_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.971 280.086C277.856 293.971 277.861 316.477 263.984 330.354C250.107 344.231 227.601 344.226 213.716 330.341C199.831 316.456 199.826 293.95 213.703 280.073C227.58 266.196 250.086 266.201 263.971 280.086Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.736 296.337C218.74 296.883 218.907 297.414 219.214 297.865C219.521 298.315 219.955 298.664 220.46 298.868C220.966 299.072 221.521 299.122 222.054 299.01C222.588 298.898 223.076 298.631 223.458 298.242C223.84 297.853 224.097 297.359 224.198 296.823C224.299 296.287 224.239 295.734 224.025 295.232C223.811 294.731 223.453 294.304 222.997 294.006C222.54 293.708 222.006 293.552 221.46 293.558C220.731 293.566 220.034 293.863 219.523 294.384C219.012 294.905 218.729 295.608 218.736 296.337Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.427 312.632C214.427 316.88 217.528 320.327 221.351 320.327C225.175 320.327 228.27 316.886 228.27 312.632V296.434C228.27 292.186 225.168 288.745 221.351 288.745C217.534 288.745 214.427 292.186 214.427 296.434V312.632Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.694 320.388H242.179V303.699C242.179 303.699 241.494 297.685 247.999 296.914C252.023 297.302 254.123 298.838 253.935 304.803C253.935 309.998 253.935 320.388 253.935 320.388H263.402V301.126C263.402 301.126 263.493 290.93 253.728 289.2C251.629 288.818 245.693 288.818 242.252 293.625V289.377H232.694V320.388Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip19_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M941.896 458.127C955.781 472.012 955.786 494.518 941.909 508.395C928.032 522.272 905.526 522.267 891.641 508.382C877.756 494.496 877.751 471.991 891.628 458.114C905.505 444.237 928.011 444.241 941.896 458.127Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.661 474.378C896.665 474.923 896.832 475.455 897.139 475.905C897.446 476.356 897.88 476.705 898.385 476.909C898.891 477.113 899.446 477.162 899.979 477.051C900.513 476.939 901.002 476.672 901.383 476.283C901.765 475.893 902.022 475.4 902.123 474.864C902.224 474.328 902.164 473.774 901.95 473.273C901.736 472.771 901.378 472.345 900.922 472.047C900.465 471.749 899.931 471.593 899.385 471.599C898.656 471.607 897.959 471.904 897.448 472.425C896.937 472.946 896.654 473.649 896.661 474.378Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.352 490.673C892.352 494.921 895.453 498.368 899.276 498.368C903.1 498.368 906.195 494.927 906.195 490.673V474.475C906.195 470.227 903.094 466.786 899.276 466.786C895.459 466.786 892.352 470.227 892.352 474.475V490.673Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.619 498.429H920.104V481.74C920.104 481.74 919.419 475.726 925.924 474.955C929.948 475.343 932.048 476.879 931.86 482.844C931.86 488.039 931.86 498.429 931.86 498.429H941.327V479.167C941.327 479.167 941.418 468.971 931.653 467.241C929.554 466.859 923.618 466.859 920.177 471.666V467.417H910.619V498.429Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip20_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M993.507 385.358C993.512 385.903 993.678 386.435 993.985 386.885C994.292 387.336 994.726 387.685 995.232 387.889C995.737 388.093 996.292 388.142 996.826 388.031C997.359 387.919 997.848 387.652 998.23 387.262C998.611 386.873 998.869 386.379 998.97 385.844C999.071 385.308 999.01 384.754 998.797 384.253C998.583 383.751 998.225 383.324 997.768 383.026C997.312 382.728 996.777 382.573 996.232 382.579C995.502 382.587 994.806 382.884 994.295 383.405C993.784 383.926 993.501 384.628 993.507 385.358Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1040.17 420.789C1054.83 406.13 1054.82 382.358 1040.16 367.692C1025.49 353.027 1001.72 353.021 987.06 367.679C972.402 382.338 972.407 406.11 987.073 420.776C1001.74 435.441 1025.51 435.447 1040.17 420.789ZM989.198 401.653C989.198 405.901 992.299 409.348 996.123 409.348C999.946 409.348 1003.04 405.907 1003.04 401.653V385.455C1003.04 381.207 999.94 377.766 996.123 377.766C992.305 377.766 989.198 381.207 989.198 385.455V401.653ZM1016.95 409.409H1007.47V378.397H1017.02V382.645C1020.46 377.839 1026.4 377.839 1028.5 378.221C1038.26 379.951 1038.17 390.146 1038.17 390.146V409.409H1028.71V393.824C1028.89 387.858 1026.79 386.323 1022.77 385.934C1016.27 386.705 1016.95 392.719 1016.95 392.719V409.409Z",
    fill: "#C4C4C4"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip21_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1135.59 102.045C1149.47 115.93 1149.48 138.436 1135.6 152.313C1121.72 166.19 1099.22 166.185 1085.33 152.3C1071.45 138.415 1071.44 115.909 1085.32 102.032C1099.2 88.1552 1121.7 88.1596 1135.59 102.045Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090.35 118.296C1090.36 118.842 1090.52 119.373 1090.83 119.824C1091.14 120.274 1091.57 120.623 1092.08 120.827C1092.58 121.031 1093.14 121.08 1093.67 120.969C1094.21 120.857 1094.69 120.59 1095.08 120.201C1095.46 119.812 1095.72 119.318 1095.82 118.782C1095.92 118.246 1095.86 117.693 1095.64 117.191C1095.43 116.69 1095.07 116.263 1094.61 115.965C1094.16 115.667 1093.62 115.511 1093.08 115.517C1092.35 115.525 1091.65 115.822 1091.14 116.343C1090.63 116.864 1090.35 117.567 1090.35 118.296Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.04 134.591C1086.04 138.839 1089.15 142.286 1092.97 142.286C1096.79 142.286 1099.89 138.845 1099.89 134.591V118.393C1099.89 114.145 1096.79 110.704 1092.97 110.704C1089.15 110.704 1086.04 114.145 1086.04 118.393V134.591Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104.31 142.347H1113.8V125.658C1113.8 125.658 1113.11 119.644 1119.62 118.873C1123.64 119.261 1125.74 120.797 1125.55 126.762C1125.55 131.957 1125.55 142.347 1125.55 142.347H1135.02V123.085C1135.02 123.085 1135.11 112.889 1125.35 111.159C1123.25 110.777 1117.31 110.777 1113.87 115.584V111.335H1104.31V142.347Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip22_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M651.357 102.045C665.242 115.93 665.247 138.436 651.37 152.313C637.493 166.19 614.987 166.185 601.102 152.3C587.216 138.415 587.212 115.909 601.089 102.032C614.966 88.1552 637.471 88.1596 651.357 102.045Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.121 118.296C606.126 118.842 606.293 119.373 606.6 119.824C606.907 120.274 607.34 120.623 607.846 120.827C608.352 121.031 608.906 121.08 609.44 120.969C609.974 120.857 610.462 120.59 610.844 120.201C611.226 119.812 611.483 119.318 611.584 118.782C611.685 118.246 611.625 117.693 611.411 117.191C611.197 116.69 610.839 116.263 610.383 115.965C609.926 115.667 609.391 115.511 608.846 115.517C608.117 115.525 607.42 115.822 606.909 116.343C606.398 116.864 606.115 117.567 606.121 118.296Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.813 134.591C601.813 138.839 604.914 142.286 608.737 142.286C612.56 142.286 615.656 138.845 615.656 134.591V118.393C615.656 114.145 612.554 110.704 608.737 110.704C604.92 110.704 601.813 114.145 601.813 118.393V134.591Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.08 142.347H629.565V125.658C629.565 125.658 628.879 119.644 635.385 118.873C639.409 119.261 641.509 120.797 641.321 126.762C641.321 131.957 641.321 142.347 641.321 142.347H650.788V123.085C650.788 123.085 650.879 112.889 641.114 111.159C639.014 110.777 633.079 110.777 629.638 115.584V111.335H620.08V142.347Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip23_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M554.51 102.045C568.396 115.93 568.4 138.436 554.523 152.313C540.646 166.19 518.141 166.185 504.255 152.3C490.37 138.415 490.366 115.909 504.242 102.032C518.119 88.1552 540.625 88.1596 554.51 102.045Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.275 118.296C509.28 118.842 509.446 119.373 509.753 119.824C510.06 120.274 510.494 120.623 511 120.827C511.505 121.031 512.06 121.08 512.594 120.969C513.127 120.857 513.616 120.59 513.998 120.201C514.379 119.812 514.637 119.318 514.738 118.782C514.839 118.246 514.778 117.693 514.564 117.191C514.351 116.69 513.993 116.263 513.536 115.965C513.08 115.667 512.545 115.511 512 115.517C511.27 115.525 510.573 115.822 510.063 116.343C509.552 116.864 509.268 117.567 509.275 118.296Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.966 134.591C504.966 138.839 508.067 142.286 511.891 142.286C515.714 142.286 518.809 138.845 518.809 134.591V118.393C518.809 114.145 515.708 110.704 511.891 110.704C508.073 110.704 504.966 114.145 504.966 118.393V134.591Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.233 142.347H532.719V125.658C532.719 125.658 532.033 119.644 538.539 118.873C542.562 119.261 544.662 120.797 544.474 126.762C544.474 131.957 544.474 142.347 544.474 142.347H553.941V123.085C553.941 123.085 554.032 112.889 544.268 111.159C542.168 110.777 536.233 110.777 532.792 115.584V111.335H523.233V142.347Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip24_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.278 191.066C84.1633 204.951 84.1677 227.457 70.2909 241.333C56.414 255.21 33.9083 255.206 20.023 241.321C6.13771 227.435 6.13323 204.93 20.0101 191.053C33.887 177.176 56.3927 177.18 70.278 191.066Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0426 207.317C25.0474 207.862 25.2139 208.394 25.5209 208.844C25.8279 209.295 26.2617 209.644 26.7673 209.848C27.2729 210.052 27.8277 210.101 28.3613 209.99C28.895 209.878 29.3836 209.611 29.7652 209.221C30.1469 208.832 30.4045 208.338 30.5054 207.803C30.6063 207.267 30.546 206.713 30.3321 206.212C30.1182 205.71 29.7604 205.283 29.3038 204.985C28.8473 204.687 28.3126 204.532 27.7675 204.538C27.0378 204.546 26.3411 204.843 25.8302 205.364C25.3194 205.885 25.0361 206.587 25.0426 207.317Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7337 223.612C20.7337 227.86 23.8349 231.307 27.6582 231.307C31.4816 231.307 34.5767 227.866 34.5767 223.612V207.414C34.5767 203.166 31.4755 199.725 27.6582 199.725C23.8409 199.725 20.7337 203.166 20.7337 207.414V223.612Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0009 231.368H48.4864V214.678C48.4864 214.678 47.8006 208.664 54.3064 207.893C58.33 208.282 60.4299 209.817 60.2417 215.783C60.2417 220.978 60.2417 231.368 60.2417 231.368H69.7091V212.105C69.7091 212.105 69.8001 201.91 60.0354 200.18C57.9356 199.798 52.0003 199.798 48.5592 204.604V200.356H39.0009V231.368Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip25_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.889 118.296C121.894 118.842 122.06 119.373 122.367 119.824C122.674 120.274 123.108 120.623 123.614 120.827C124.119 121.031 124.674 121.08 125.208 120.969C125.741 120.857 126.23 120.59 126.612 120.201C126.993 119.812 127.251 119.318 127.352 118.782C127.453 118.246 127.392 117.693 127.179 117.191C126.965 116.69 126.607 116.263 126.15 115.965C125.694 115.667 125.159 115.511 124.614 115.517C123.884 115.525 123.188 115.822 122.677 116.343C122.166 116.864 121.883 117.567 121.889 118.296Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.551 153.727C183.21 139.068 183.204 115.296 168.539 100.631C153.873 85.9649 130.101 85.9591 115.442 100.618C100.784 115.276 100.789 139.048 115.455 153.714C130.121 168.38 153.893 168.385 168.551 153.727ZM117.58 134.591C117.58 138.839 120.681 142.286 124.505 142.286C128.328 142.286 131.423 138.845 131.423 134.591V118.393C131.423 114.145 128.322 110.704 124.505 110.704C120.687 110.704 117.58 114.145 117.58 118.393V134.591ZM145.333 142.347H135.847V111.335H145.406V115.584C148.847 110.777 154.782 110.777 156.882 111.159C166.647 112.889 166.556 123.085 166.556 123.085V142.347H157.088V126.762C157.276 120.797 155.177 119.261 151.153 118.873C144.647 119.644 145.333 125.658 145.333 125.658V142.347Z",
    fill: "#C4C4C4"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip26_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M554.51 547.147C568.396 561.033 568.4 583.538 554.523 597.415C540.646 611.292 518.141 611.288 504.255 597.402C490.37 583.517 490.366 561.011 504.242 547.134C518.119 533.258 540.625 533.262 554.51 547.147Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.275 563.399C509.28 563.944 509.446 564.475 509.753 564.926C510.06 565.376 510.494 565.726 511 565.93C511.505 566.134 512.06 566.183 512.594 566.071C513.127 565.96 513.616 565.692 513.998 565.303C514.379 564.914 514.637 564.42 514.738 563.884C514.839 563.349 514.778 562.795 514.564 562.293C514.351 561.792 513.993 561.365 513.536 561.067C513.08 560.769 512.545 560.613 512 560.619C511.27 560.627 510.573 560.924 510.063 561.446C509.552 561.967 509.268 562.669 509.275 563.399Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.966 579.694C504.966 583.942 508.067 587.389 511.891 587.389C515.714 587.389 518.809 583.948 518.809 579.694V563.496C518.809 559.248 515.708 555.807 511.891 555.807C508.073 555.807 504.966 559.248 504.966 563.496V579.694Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.233 587.45H532.719V570.76C532.719 570.76 532.033 564.746 538.539 563.975C542.562 564.364 544.662 565.899 544.474 571.865C544.474 577.06 544.474 587.45 544.474 587.45H553.941V568.187C553.941 568.187 554.032 557.991 544.268 556.262C542.168 555.88 536.233 555.88 532.792 560.686V556.438H523.233V587.45Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip27_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1232.44 13.0245C1246.32 26.9098 1246.33 49.4155 1232.45 63.2924C1218.57 77.1693 1196.07 77.1648 1182.18 63.2795C1168.3 49.3942 1168.29 26.8886 1182.17 13.0117C1196.04 -0.865213 1218.55 -0.860742 1232.44 13.0245Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187.2 29.276C1187.2 29.8212 1187.37 30.3527 1187.68 30.8032C1187.99 31.2537 1188.42 31.603 1188.92 31.8069C1189.43 32.0108 1189.99 32.0601 1190.52 31.9486C1191.05 31.8371 1191.54 31.5697 1191.92 31.1804C1192.3 30.7911 1192.56 30.2973 1192.66 29.7616C1192.76 29.2258 1192.7 28.6722 1192.49 28.1707C1192.28 27.6692 1191.92 27.2425 1191.46 26.9444C1191 26.6464 1190.47 26.4905 1189.92 26.4965C1189.2 26.5045 1188.5 26.8017 1187.99 27.3228C1187.48 27.8439 1187.19 28.5463 1187.2 29.276Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1182.89 45.5707C1182.89 49.8189 1185.99 53.266 1189.82 53.266C1193.64 53.266 1196.73 49.8249 1196.73 45.5707V29.3731C1196.73 25.1249 1193.63 21.6838 1189.82 21.6838C1186 21.6838 1182.89 25.1249 1182.89 29.3731V45.5707Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.16 53.3266H1210.64V36.6374C1210.64 36.6374 1209.96 30.6232 1216.46 29.8525C1220.49 30.2409 1222.59 31.7763 1222.4 37.7419C1222.4 42.9368 1222.4 53.3266 1222.4 53.3266H1231.87V34.0642C1231.87 34.0642 1231.96 23.8686 1222.19 22.139C1220.09 21.7566 1214.16 21.7567 1210.72 26.5632V22.315H1201.16V53.3266Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip28_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M941.896 13.0245C955.781 26.9098 955.786 49.4155 941.909 63.2924C928.032 77.1693 905.526 77.1648 891.641 63.2795C877.756 49.3942 877.751 26.8886 891.628 13.0117C905.505 -0.865213 928.011 -0.860742 941.896 13.0245Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.661 29.276C896.665 29.8212 896.832 30.3527 897.139 30.8032C897.446 31.2537 897.88 31.603 898.385 31.8069C898.891 32.0108 899.446 32.0601 899.979 31.9486C900.513 31.8371 901.002 31.5697 901.383 31.1804C901.765 30.7911 902.022 30.2973 902.123 29.7616C902.224 29.2258 902.164 28.6722 901.95 28.1707C901.736 27.6692 901.378 27.2425 900.922 26.9444C900.465 26.6464 899.931 26.4905 899.385 26.4965C898.656 26.5045 897.959 26.8017 897.448 27.3228C896.937 27.8439 896.654 28.5463 896.661 29.276Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.352 45.5707C892.352 49.8189 895.453 53.266 899.276 53.266C903.1 53.266 906.195 49.8249 906.195 45.5707V29.3731C906.195 25.1249 903.094 21.6838 899.276 21.6838C895.459 21.6838 892.352 25.1249 892.352 29.3731V45.5707Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.619 53.3266H920.104V36.6374C920.104 36.6374 919.419 30.6232 925.924 29.8525C929.948 30.2409 932.048 31.7763 931.86 37.7419C931.86 42.9368 931.86 53.3266 931.86 53.3266H941.327V34.0642C941.327 34.0642 941.418 23.8686 931.653 22.139C929.554 21.7566 923.618 21.7567 920.177 26.5632V22.315H910.619V53.3266Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip29_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M845.05 13.0245C858.935 26.9098 858.939 49.4155 845.062 63.2924C831.186 77.1693 808.68 77.1648 794.795 63.2795C780.909 49.3942 780.905 26.8886 794.782 13.0117C808.659 -0.865213 831.164 -0.860742 845.05 13.0245Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.814 29.276C799.819 29.8212 799.985 30.3527 800.293 30.8032C800.6 31.2537 801.033 31.603 801.539 31.8069C802.045 32.0108 802.599 32.0601 803.133 31.9486C803.667 31.8371 804.155 31.5697 804.537 31.1804C804.918 30.7911 805.176 30.2973 805.277 29.7616C805.378 29.2258 805.318 28.6722 805.104 28.1707C804.89 27.6692 804.532 27.2425 804.075 26.9444C803.619 26.6464 803.084 26.4905 802.539 26.4965C801.809 26.5045 801.113 26.8017 800.602 27.3228C800.091 27.8439 799.808 28.5463 799.814 29.276Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.505 45.5707C795.505 49.8189 798.607 53.266 802.43 53.266C806.253 53.266 809.348 49.8249 809.348 45.5707V29.3731C809.348 25.1249 806.247 21.6838 802.43 21.6838C798.613 21.6838 795.505 25.1249 795.505 29.3731V45.5707Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.772 53.3266H823.258V36.6374C823.258 36.6374 822.572 30.6232 829.078 29.8525C833.102 30.2409 835.201 31.7763 835.013 37.7419C835.013 42.9368 835.013 53.3266 835.013 53.3266H844.481V34.0642C844.481 34.0642 844.572 23.8686 834.807 22.139C832.707 21.7566 826.772 21.7567 823.331 26.5632V22.315H813.772V53.3266Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip30_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.971 102.045C277.856 115.93 277.861 138.436 263.984 152.313C250.107 166.19 227.601 166.185 213.716 152.3C199.831 138.415 199.826 115.909 213.703 102.032C227.58 88.1552 250.086 88.1596 263.971 102.045Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.736 118.296C218.74 118.842 218.907 119.373 219.214 119.824C219.521 120.274 219.955 120.623 220.46 120.827C220.966 121.031 221.521 121.08 222.054 120.969C222.588 120.857 223.076 120.59 223.458 120.201C223.84 119.812 224.097 119.318 224.198 118.782C224.299 118.246 224.239 117.693 224.025 117.191C223.811 116.69 223.453 116.263 222.997 115.965C222.54 115.667 222.006 115.511 221.46 115.517C220.731 115.525 220.034 115.822 219.523 116.343C219.012 116.864 218.729 117.567 218.736 118.296Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.427 134.591C214.427 138.839 217.528 142.286 221.351 142.286C225.175 142.286 228.27 138.845 228.27 134.591V118.393C228.27 114.145 225.168 110.704 221.351 110.704C217.534 110.704 214.427 114.145 214.427 118.393V134.591Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.694 142.347H242.179V125.658C242.179 125.658 241.494 119.644 247.999 118.873C252.023 119.261 254.123 120.797 253.935 126.762C253.935 131.957 253.935 142.347 253.935 142.347H263.402V123.085C263.402 123.085 263.493 112.889 253.728 111.159C251.629 110.777 245.693 110.777 242.252 115.584V111.335H232.694V142.347Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip31_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.582 385.358C315.587 385.903 315.753 386.435 316.06 386.885C316.367 387.336 316.801 387.685 317.307 387.889C317.812 388.093 318.367 388.142 318.901 388.031C319.434 387.919 319.923 387.652 320.305 387.262C320.686 386.873 320.944 386.379 321.045 385.844C321.146 385.308 321.085 384.754 320.872 384.253C320.658 383.751 320.3 383.324 319.843 383.026C319.387 382.728 318.852 382.573 318.307 382.579C317.577 382.587 316.881 382.884 316.37 383.405C315.859 383.926 315.576 384.628 315.582 385.358Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.244 420.789C376.903 406.13 376.897 382.358 362.232 367.692C347.566 353.027 323.794 353.021 309.135 367.679C294.477 382.338 294.482 406.11 309.148 420.776C323.814 435.441 347.586 435.447 362.244 420.789ZM311.273 401.653C311.273 405.901 314.374 409.348 318.198 409.348C322.021 409.348 325.116 405.907 325.116 401.653V385.455C325.116 381.207 322.015 377.766 318.198 377.766C314.38 377.766 311.273 381.207 311.273 385.455V401.653ZM339.026 409.409H329.54V378.397H339.099V382.645C342.54 377.839 348.475 377.839 350.575 378.221C360.34 379.951 360.249 390.146 360.249 390.146V409.409H350.781V393.824C350.969 387.858 348.87 386.323 344.846 385.934C338.34 386.705 339.026 392.719 339.026 392.719V409.409Z",
    fill: "#C4C4C4"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip32_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1090.35 29.276C1090.36 29.8212 1090.52 30.3527 1090.83 30.8032C1091.14 31.2537 1091.57 31.603 1092.08 31.8069C1092.58 32.0108 1093.14 32.0601 1093.67 31.9486C1094.21 31.8371 1094.69 31.5697 1095.08 31.1804C1095.46 30.7911 1095.72 30.2973 1095.82 29.7616C1095.92 29.2258 1095.86 28.6722 1095.64 28.1707C1095.43 27.6692 1095.07 27.2425 1094.61 26.9444C1094.16 26.6464 1093.62 26.4905 1093.08 26.4965C1092.35 26.5045 1091.65 26.8017 1091.14 27.3228C1090.63 27.8439 1090.35 28.5463 1090.35 29.276Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1137.02 64.7065C1151.67 50.0479 1151.67 26.2759 1137 11.6102C1122.34 -3.05547 1098.57 -3.06124 1083.91 11.5973C1069.25 26.2559 1069.25 50.0279 1083.92 64.6936C1098.59 79.3593 1122.36 79.3651 1137.02 64.7065ZM1086.04 45.5707C1086.04 49.8188 1089.15 53.2659 1092.97 53.2659C1096.79 53.2659 1099.89 49.8249 1099.89 45.5707V29.373C1099.89 25.1248 1096.79 21.6838 1092.97 21.6838C1089.15 21.6838 1086.04 25.1248 1086.04 29.373V45.5707ZM1113.8 53.3266H1104.31V22.315H1113.87V26.5632C1117.31 21.7567 1123.25 21.7566 1125.35 22.139C1135.11 23.8686 1135.02 34.0642 1135.02 34.0642V53.3266H1125.55V37.7419C1125.74 31.7763 1123.64 30.2409 1119.62 29.8524C1113.11 30.6232 1113.8 36.6374 1113.8 36.6374V53.3266Z",
    fill: "#C4C4C4"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip33_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M748.203 13.0245C762.088 26.9098 762.093 49.4155 748.216 63.2924C734.339 77.1693 711.833 77.1648 697.948 63.2795C684.063 49.3942 684.058 26.8886 697.935 13.0117C711.812 -0.865213 734.318 -0.860742 748.203 13.0245Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.968 29.276C702.972 29.8212 703.139 30.3527 703.446 30.8032C703.753 31.2537 704.187 31.603 704.692 31.8069C705.198 32.0108 705.753 32.0601 706.286 31.9486C706.82 31.8371 707.309 31.5697 707.69 31.1804C708.072 30.7911 708.33 30.2973 708.43 29.7616C708.531 29.2258 708.471 28.6722 708.257 28.1707C708.043 27.6692 707.685 27.2425 707.229 26.9444C706.772 26.6464 706.238 26.4905 705.693 26.4965C704.963 26.5045 704.266 26.8017 703.755 27.3228C703.244 27.8439 702.961 28.5463 702.968 29.276Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.659 45.5707C698.659 49.8189 701.76 53.266 705.583 53.266C709.407 53.266 712.502 49.8249 712.502 45.5707V29.3731C712.502 25.1249 709.401 21.6838 705.583 21.6838C701.766 21.6838 698.659 25.1249 698.659 29.3731V45.5707Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.926 53.3266H726.412V36.6374C726.412 36.6374 725.726 30.6232 732.231 29.8525C736.255 30.2409 738.355 31.7763 738.167 37.7419C738.167 42.9368 738.167 53.3266 738.167 53.3266H747.634V34.0642C747.634 34.0642 747.725 23.8686 737.96 22.139C735.861 21.7566 729.925 21.7567 726.484 26.5632V22.315H716.926V53.3266Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip34_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1426.13 13.0245C1440.01 26.9098 1440.02 49.4155 1426.14 63.2924C1412.26 77.1693 1389.76 77.1648 1375.87 63.2795C1361.99 49.3942 1361.98 26.8886 1375.86 13.0117C1389.74 -0.865213 1412.24 -0.860742 1426.13 13.0245Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380.89 29.276C1380.9 29.8212 1381.06 30.3527 1381.37 30.8032C1381.68 31.2537 1382.11 31.603 1382.62 31.8069C1383.12 32.0108 1383.68 32.0601 1384.21 31.9486C1384.75 31.8371 1385.23 31.5697 1385.62 31.1804C1386 30.7911 1386.25 30.2973 1386.36 29.7616C1386.46 29.2258 1386.4 28.6722 1386.18 28.1707C1385.97 27.6692 1385.61 27.2425 1385.15 26.9444C1384.7 26.6464 1384.16 26.4905 1383.62 26.4965C1382.89 26.5045 1382.19 26.8017 1381.68 27.3228C1381.17 27.8439 1380.89 28.5463 1380.89 29.276Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.58 45.5707C1376.58 49.8189 1379.69 53.266 1383.51 53.266C1387.33 53.266 1390.43 49.8249 1390.43 45.5707V29.3731C1390.43 25.1249 1387.33 21.6838 1383.51 21.6838C1379.69 21.6838 1376.58 25.1249 1376.58 29.3731V45.5707Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1394.85 53.3266H1404.34V36.6374C1404.34 36.6374 1403.65 30.6232 1410.16 29.8525C1414.18 30.2409 1416.28 31.7763 1416.09 37.7419C1416.09 42.9368 1416.09 53.3266 1416.09 53.3266H1425.56V34.0642C1425.56 34.0642 1425.65 23.8686 1415.89 22.139C1413.79 21.7566 1407.85 21.7567 1404.41 26.5632V22.315H1394.85V53.3266Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip35_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.121 29.276C606.126 29.8212 606.293 30.3527 606.6 30.8032C606.907 31.2537 607.34 31.603 607.846 31.8069C608.352 32.0108 608.906 32.0601 609.44 31.9486C609.974 31.8371 610.462 31.5697 610.844 31.1804C611.226 30.7911 611.483 30.2973 611.584 29.7616C611.685 29.2258 611.625 28.6722 611.411 28.1707C611.197 27.6692 610.839 27.2425 610.383 26.9444C609.926 26.6464 609.391 26.4905 608.846 26.4965C608.117 26.5045 607.42 26.8017 606.909 27.3228C606.398 27.8439 606.115 28.5463 606.121 29.276Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M652.784 64.7065C667.442 50.0479 667.437 26.2759 652.771 11.6102C638.105 -3.05547 614.333 -3.06124 599.675 11.5973C585.016 26.2559 585.022 50.0279 599.688 64.6936C614.353 79.3593 638.125 79.3651 652.784 64.7065ZM601.813 45.5707C601.813 49.8188 604.914 53.2659 608.737 53.2659C612.56 53.2659 615.656 49.8249 615.656 45.5707V29.373C615.656 25.1248 612.554 21.6838 608.737 21.6838C604.92 21.6838 601.813 25.1248 601.813 29.373V45.5707ZM629.565 53.3266H620.08V22.315H629.638V26.5632C633.079 21.7567 639.014 21.7566 641.114 22.139C650.879 23.8686 650.788 34.0642 650.788 34.0642V53.3266H641.321V37.7419C641.509 31.7763 639.409 30.2409 635.385 29.8524C628.88 30.6232 629.565 36.6374 629.565 36.6374V53.3266Z",
    fill: "#C4C4C4"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip36_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.278 13.0245C84.1633 26.9098 84.1677 49.4155 70.2909 63.2924C56.414 77.1693 33.9083 77.1648 20.023 63.2795C6.13771 49.3942 6.13323 26.8886 20.0101 13.0117C33.887 -0.865213 56.3927 -0.860742 70.278 13.0245Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0426 29.276C25.0474 29.8212 25.2139 30.3527 25.5209 30.8032C25.8279 31.2537 26.2617 31.603 26.7673 31.8069C27.2729 32.0108 27.8277 32.0601 28.3613 31.9486C28.895 31.8371 29.3836 31.5697 29.7652 31.1804C30.1469 30.7911 30.4045 30.2973 30.5054 29.7616C30.6063 29.2258 30.546 28.6722 30.3321 28.1707C30.1182 27.6692 29.7604 27.2425 29.3038 26.9444C28.8473 26.6464 28.3126 26.4905 27.7675 26.4965C27.0378 26.5045 26.3411 26.8017 25.8302 27.3228C25.3194 27.8439 25.0361 28.5463 25.0426 29.276Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7337 45.5707C20.7337 49.8189 23.8349 53.266 27.6582 53.266C31.4816 53.266 34.5767 49.8249 34.5767 45.5707V29.3731C34.5767 25.1249 31.4755 21.6838 27.6582 21.6838C23.8409 21.6838 20.7337 25.1249 20.7337 29.3731V45.5707Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0009 53.3266H48.4864V36.6374C48.4864 36.6374 47.8006 30.6232 54.3064 29.8525C58.33 30.2409 60.4299 31.7763 60.2417 37.7419C60.2417 42.9368 60.2417 53.3266 60.2417 53.3266H69.7091V34.0642C69.7091 34.0642 69.8001 23.8686 60.0354 22.139C57.9356 21.7566 52.0003 21.7567 48.5592 26.5632V22.315H39.0009V53.3266Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip37_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.124 13.0245C181.01 26.9098 181.014 49.4155 167.137 63.2924C153.26 77.1693 130.755 77.1648 116.869 63.2795C102.984 49.3942 102.98 26.8886 116.857 13.0117C130.733 -0.865213 153.239 -0.860742 167.124 13.0245Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.889 29.276C121.894 29.8212 122.06 30.3527 122.367 30.8032C122.674 31.2537 123.108 31.603 123.614 31.8069C124.119 32.0108 124.674 32.0601 125.208 31.9486C125.741 31.8371 126.23 31.5697 126.612 31.1804C126.993 30.7911 127.251 30.2973 127.352 29.7616C127.453 29.2258 127.392 28.6722 127.179 28.1707C126.965 27.6692 126.607 27.2425 126.15 26.9444C125.694 26.6464 125.159 26.4905 124.614 26.4965C123.884 26.5045 123.188 26.8017 122.677 27.3228C122.166 27.8439 121.883 28.5463 121.889 29.276Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.58 45.5707C117.58 49.8189 120.681 53.266 124.505 53.266C128.328 53.266 131.423 49.8249 131.423 45.5707V29.3731C131.423 25.1249 128.322 21.6838 124.505 21.6838C120.687 21.6838 117.58 25.1249 117.58 29.3731V45.5707Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.847 53.3266H145.333V36.6374C145.333 36.6374 144.647 30.6232 151.153 29.8525C155.176 30.2409 157.276 31.7763 157.088 37.7419C157.088 42.9368 157.088 53.3266 157.088 53.3266H166.556V34.0642C166.556 34.0642 166.647 23.8686 156.882 22.139C154.782 21.7566 148.847 21.7567 145.406 26.5632V22.315H135.847V53.3266Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip38_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.582 207.317C315.587 207.862 315.753 208.394 316.06 208.844C316.367 209.295 316.801 209.644 317.307 209.848C317.812 210.052 318.367 210.101 318.901 209.99C319.434 209.878 319.923 209.611 320.305 209.221C320.686 208.832 320.944 208.338 321.045 207.803C321.146 207.267 321.085 206.713 320.872 206.212C320.658 205.71 320.3 205.283 319.843 204.985C319.387 204.687 318.852 204.532 318.307 204.538C317.577 204.546 316.881 204.843 316.37 205.364C315.859 205.885 315.576 206.587 315.582 207.317Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.244 242.748C376.903 228.089 376.897 204.317 362.232 189.651C347.566 174.986 323.794 174.98 309.135 189.638C294.477 204.297 294.482 228.069 309.148 242.735C323.814 257.4 347.586 257.406 362.244 242.748ZM311.273 223.612C311.273 227.86 314.374 231.307 318.198 231.307C322.021 231.307 325.116 227.866 325.116 223.612V207.414C325.116 203.166 322.015 199.725 318.198 199.725C314.38 199.725 311.273 203.166 311.273 207.414V223.612ZM339.026 231.368H329.54V200.356H339.099V204.604C342.54 199.798 348.475 199.798 350.575 200.18C360.34 201.91 360.249 212.105 360.249 212.105V231.368H350.781V215.783C350.969 209.817 348.87 208.282 344.846 207.893C338.34 208.664 339.026 214.678 339.026 214.678V231.368Z",
    fill: "#C4C4C4"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip39_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M748.203 458.127C762.088 472.012 762.093 494.518 748.216 508.395C734.339 522.272 711.833 522.267 697.948 508.382C684.063 494.496 684.058 471.991 697.935 458.114C711.812 444.237 734.318 444.241 748.203 458.127Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.968 474.378C702.972 474.923 703.139 475.455 703.446 475.905C703.753 476.356 704.187 476.705 704.692 476.909C705.198 477.113 705.753 477.162 706.286 477.051C706.82 476.939 707.309 476.672 707.69 476.283C708.072 475.893 708.33 475.4 708.43 474.864C708.531 474.328 708.471 473.774 708.257 473.273C708.043 472.771 707.685 472.345 707.229 472.047C706.772 471.749 706.238 471.593 705.693 471.599C704.963 471.607 704.266 471.904 703.755 472.425C703.244 472.946 702.961 473.649 702.968 474.378Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.659 490.673C698.659 494.921 701.76 498.368 705.583 498.368C709.407 498.368 712.502 494.927 712.502 490.673V474.475C712.502 470.227 709.401 466.786 705.583 466.786C701.766 466.786 698.659 470.227 698.659 474.475V490.673Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.926 498.429H726.412V481.74C726.412 481.74 725.726 475.726 732.231 474.955C736.255 475.343 738.355 476.879 738.167 482.844C738.167 488.039 738.167 498.429 738.167 498.429H747.634V479.167C747.634 479.167 747.725 468.971 737.96 467.241C735.861 466.859 729.925 466.859 726.484 471.666V467.417H716.926V498.429Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip40_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1232.44 458.127C1246.32 472.012 1246.33 494.518 1232.45 508.395C1218.57 522.272 1196.07 522.267 1182.18 508.382C1168.3 494.496 1168.29 471.991 1182.17 458.114C1196.04 444.237 1218.55 444.241 1232.44 458.127Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187.2 474.378C1187.2 474.923 1187.37 475.455 1187.68 475.905C1187.99 476.356 1188.42 476.705 1188.92 476.909C1189.43 477.113 1189.99 477.162 1190.52 477.051C1191.05 476.939 1191.54 476.672 1191.92 476.283C1192.3 475.893 1192.56 475.4 1192.66 474.864C1192.76 474.328 1192.7 473.774 1192.49 473.273C1192.28 472.771 1191.92 472.345 1191.46 472.047C1191 471.749 1190.47 471.593 1189.92 471.599C1189.2 471.607 1188.5 471.904 1187.99 472.425C1187.48 472.946 1187.19 473.649 1187.2 474.378Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1182.89 490.673C1182.89 494.921 1185.99 498.368 1189.82 498.368C1193.64 498.368 1196.73 494.927 1196.73 490.673V474.475C1196.73 470.227 1193.63 466.786 1189.82 466.786C1186 466.786 1182.89 470.227 1182.89 474.475V490.673Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.16 498.429H1210.64V481.74C1210.64 481.74 1209.96 475.726 1216.46 474.955C1220.49 475.343 1222.59 476.879 1222.4 482.844C1222.4 488.039 1222.4 498.429 1222.4 498.429H1231.87V479.167C1231.87 479.167 1231.96 468.971 1222.19 467.241C1220.09 466.859 1214.16 466.859 1210.72 471.666V467.417H1201.16V498.429Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip41_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1329.28 191.066C1343.17 204.951 1343.17 227.457 1329.29 241.333C1315.42 255.21 1292.91 255.206 1279.03 241.321C1265.14 227.435 1265.14 204.93 1279.01 191.053C1292.89 177.176 1315.4 177.18 1329.28 191.066Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1284.05 207.317C1284.05 207.862 1284.22 208.394 1284.52 208.844C1284.83 209.295 1285.27 209.644 1285.77 209.848C1286.28 210.052 1286.83 210.101 1287.37 209.99C1287.9 209.878 1288.39 209.611 1288.77 209.221C1289.15 208.832 1289.41 208.338 1289.51 207.803C1289.61 207.267 1289.55 206.713 1289.34 206.212C1289.12 205.71 1288.76 205.283 1288.31 204.985C1287.85 204.687 1287.32 204.532 1286.77 204.538C1286.04 204.546 1285.34 204.843 1284.83 205.364C1284.32 205.885 1284.04 206.587 1284.05 207.317Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.74 223.612C1279.74 227.86 1282.84 231.307 1286.66 231.307C1290.49 231.307 1293.58 227.866 1293.58 223.612V207.414C1293.58 203.166 1290.48 199.725 1286.66 199.725C1282.84 199.725 1279.74 203.166 1279.74 207.414V223.612Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298 231.368H1307.49V214.678C1307.49 214.678 1306.8 208.664 1313.31 207.893C1317.33 208.282 1319.43 209.817 1319.25 215.783C1319.25 220.978 1319.25 231.368 1319.25 231.368H1328.71V212.105C1328.71 212.105 1328.8 201.91 1319.04 200.18C1316.94 199.798 1311 199.798 1307.56 204.604V200.356H1298V231.368Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip42_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.971 369.107C277.856 382.992 277.861 405.498 263.984 419.374C250.107 433.251 227.601 433.247 213.716 419.362C199.831 405.476 199.826 382.971 213.703 369.094C227.58 355.217 250.086 355.221 263.971 369.107Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.736 385.358C218.74 385.903 218.907 386.435 219.214 386.885C219.521 387.336 219.955 387.685 220.46 387.889C220.966 388.093 221.521 388.142 222.054 388.031C222.588 387.919 223.076 387.652 223.458 387.262C223.84 386.873 224.097 386.379 224.198 385.844C224.299 385.308 224.239 384.754 224.025 384.253C223.811 383.751 223.453 383.324 222.997 383.026C222.54 382.728 222.006 382.573 221.46 382.579C220.731 382.587 220.034 382.884 219.523 383.405C219.012 383.926 218.729 384.628 218.736 385.358Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.427 401.653C214.427 405.901 217.528 409.348 221.351 409.348C225.175 409.348 228.27 405.907 228.27 401.653V385.455C228.27 381.207 225.168 377.766 221.351 377.766C217.534 377.766 214.427 381.207 214.427 385.455V401.653Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.694 409.409H242.179V392.719C242.179 392.719 241.494 386.705 247.999 385.934C252.023 386.323 254.123 387.858 253.935 393.824C253.935 399.019 253.935 409.409 253.935 409.409H263.402V390.146C263.402 390.146 263.493 379.951 253.728 378.221C251.629 377.839 245.693 377.839 242.252 382.645V378.397H232.694V409.409Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip43_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M896.661 563.399C896.665 563.944 896.832 564.475 897.139 564.926C897.446 565.376 897.88 565.726 898.385 565.93C898.891 566.134 899.446 566.183 899.979 566.071C900.513 565.96 901.002 565.692 901.383 565.303C901.765 564.914 902.022 564.42 902.123 563.884C902.224 563.349 902.164 562.795 901.95 562.293C901.736 561.792 901.378 561.365 900.922 561.067C900.465 560.769 899.931 560.613 899.385 560.619C898.656 560.627 897.959 560.924 897.448 561.446C896.937 561.967 896.654 562.669 896.661 563.399Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M943.323 598.829C957.982 584.171 957.976 560.399 943.31 545.733C928.644 531.067 904.872 531.062 890.214 545.72C875.555 560.379 875.561 584.151 890.227 598.816C904.892 613.482 928.664 613.488 943.323 598.829ZM892.352 579.694C892.352 583.942 895.453 587.389 899.276 587.389C903.1 587.389 906.195 583.948 906.195 579.694V563.496C906.195 559.248 903.094 555.807 899.276 555.807C895.459 555.807 892.352 559.248 892.352 563.496V579.694ZM920.104 587.449H910.619V556.438H920.177V560.686C923.618 555.88 929.554 555.879 931.653 556.262C941.418 557.991 941.327 568.187 941.327 568.187V587.449H931.86V571.865C932.048 565.899 929.948 564.364 925.924 563.975C919.419 564.746 920.104 570.76 920.104 570.76V587.449Z",
    fill: "#C4C4C4"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip44_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M748.203 369.107C762.088 382.992 762.093 405.498 748.216 419.374C734.339 433.251 711.833 433.247 697.948 419.362C684.063 405.476 684.058 382.971 697.935 369.094C711.812 355.217 734.318 355.221 748.203 369.107Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.968 385.358C702.972 385.903 703.139 386.435 703.446 386.885C703.753 387.336 704.187 387.685 704.692 387.889C705.198 388.093 705.753 388.142 706.286 388.031C706.82 387.919 707.309 387.652 707.69 387.262C708.072 386.873 708.33 386.379 708.43 385.844C708.531 385.308 708.471 384.754 708.257 384.253C708.043 383.751 707.685 383.324 707.229 383.026C706.772 382.728 706.238 382.573 705.693 382.579C704.963 382.587 704.266 382.884 703.755 383.405C703.244 383.926 702.961 384.628 702.968 385.358Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.659 401.653C698.659 405.901 701.76 409.348 705.583 409.348C709.407 409.348 712.502 405.907 712.502 401.653V385.455C712.502 381.207 709.401 377.766 705.583 377.766C701.766 377.766 698.659 381.207 698.659 385.455V401.653Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.926 409.409H726.412V392.719C726.412 392.719 725.726 386.705 732.231 385.934C736.255 386.323 738.355 387.858 738.167 393.824C738.167 399.019 738.167 409.409 738.167 409.409H747.634V390.146C747.634 390.146 747.725 379.951 737.96 378.221C735.861 377.839 729.925 377.839 726.484 382.645V378.397H716.926V409.409Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip45_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.664 547.147C471.549 561.033 471.553 583.538 457.676 597.415C443.8 611.292 421.294 611.288 407.409 597.402C393.523 583.517 393.519 561.011 407.396 547.134C421.273 533.258 443.778 533.262 457.664 547.147Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.428 563.399C412.433 563.944 412.6 564.475 412.907 564.926C413.214 565.376 413.647 565.726 414.153 565.93C414.659 566.134 415.213 566.183 415.747 566.071C416.281 565.96 416.769 565.692 417.151 565.303C417.532 564.914 417.79 564.42 417.891 563.884C417.992 563.349 417.932 562.795 417.718 562.293C417.504 561.792 417.146 561.365 416.689 561.067C416.233 560.769 415.698 560.613 415.153 560.619C414.423 560.627 413.727 560.924 413.216 561.446C412.705 561.967 412.422 562.669 412.428 563.399Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.119 579.694C408.119 583.942 411.22 587.389 415.044 587.389C418.867 587.389 421.962 583.948 421.962 579.694V563.496C421.962 559.248 418.861 555.807 415.044 555.807C411.227 555.807 408.119 559.248 408.119 563.496V579.694Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.387 587.45H435.872V570.76C435.872 570.76 435.186 564.746 441.692 563.975C445.716 564.364 447.816 565.899 447.627 571.865C447.627 577.06 447.627 587.45 447.627 587.45H457.095V568.187C457.095 568.187 457.186 557.991 447.421 556.262C445.321 555.88 439.386 555.88 435.945 560.686V556.438H426.387V587.45Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip46_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1426.13 280.086C1440.01 293.971 1440.02 316.477 1426.14 330.354C1412.26 344.231 1389.76 344.226 1375.87 330.341C1361.99 316.456 1361.98 293.95 1375.86 280.073C1389.74 266.196 1412.24 266.201 1426.13 280.086Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380.89 296.337C1380.9 296.883 1381.06 297.414 1381.37 297.865C1381.68 298.315 1382.11 298.664 1382.62 298.868C1383.12 299.072 1383.68 299.122 1384.21 299.01C1384.75 298.898 1385.23 298.631 1385.62 298.242C1386 297.853 1386.25 297.359 1386.36 296.823C1386.46 296.287 1386.4 295.734 1386.18 295.232C1385.97 294.731 1385.61 294.304 1385.15 294.006C1384.7 293.708 1384.16 293.552 1383.62 293.558C1382.89 293.566 1382.19 293.863 1381.68 294.384C1381.17 294.905 1380.89 295.608 1380.89 296.337Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.58 312.632C1376.58 316.88 1379.69 320.327 1383.51 320.327C1387.33 320.327 1390.43 316.886 1390.43 312.632V296.434C1390.43 292.186 1387.33 288.745 1383.51 288.745C1379.69 288.745 1376.58 292.186 1376.58 296.434V312.632Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1394.85 320.388H1404.34V303.699C1404.34 303.699 1403.65 297.685 1410.16 296.914C1414.18 297.302 1416.28 298.838 1416.09 304.803C1416.09 309.998 1416.09 320.388 1416.09 320.388H1425.56V301.126C1425.56 301.126 1425.65 290.93 1415.89 289.2C1413.79 288.818 1407.85 288.818 1404.41 293.625V289.377H1394.85V320.388Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip47_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.664 369.107C471.549 382.992 471.553 405.498 457.676 419.374C443.8 433.251 421.294 433.247 407.409 419.362C393.523 405.476 393.519 382.971 407.396 369.094C421.273 355.217 443.778 355.221 457.664 369.107Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.428 385.358C412.433 385.903 412.6 386.435 412.907 386.885C413.214 387.336 413.647 387.685 414.153 387.889C414.659 388.093 415.213 388.142 415.747 388.031C416.281 387.919 416.769 387.652 417.151 387.262C417.532 386.873 417.79 386.379 417.891 385.844C417.992 385.308 417.932 384.754 417.718 384.253C417.504 383.751 417.146 383.324 416.689 383.026C416.233 382.728 415.698 382.573 415.153 382.579C414.423 382.587 413.727 382.884 413.216 383.405C412.705 383.926 412.422 384.628 412.428 385.358Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.119 401.653C408.119 405.901 411.22 409.348 415.044 409.348C418.867 409.348 421.962 405.907 421.962 401.653V385.455C421.962 381.207 418.861 377.766 415.044 377.766C411.227 377.766 408.119 381.207 408.119 385.455V401.653Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.387 409.409H435.872V392.719C435.872 392.719 435.186 386.705 441.692 385.934C445.716 386.323 447.816 387.858 447.627 393.824C447.627 399.019 447.627 409.409 447.627 409.409H457.095V390.146C457.095 390.146 457.186 379.951 447.421 378.221C445.321 377.839 439.386 377.839 435.945 382.645V378.397H426.387V409.409Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip48_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M651.357 458.127C665.242 472.012 665.247 494.518 651.37 508.395C637.493 522.272 614.987 522.267 601.102 508.382C587.216 494.496 587.212 471.991 601.089 458.114C614.966 444.237 637.471 444.241 651.357 458.127Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.121 474.378C606.126 474.923 606.293 475.455 606.6 475.905C606.907 476.356 607.34 476.705 607.846 476.909C608.352 477.113 608.906 477.162 609.44 477.051C609.974 476.939 610.462 476.672 610.844 476.283C611.226 475.893 611.483 475.4 611.584 474.864C611.685 474.328 611.625 473.774 611.411 473.273C611.197 472.771 610.839 472.345 610.383 472.047C609.926 471.749 609.391 471.593 608.846 471.599C608.117 471.607 607.42 471.904 606.909 472.425C606.398 472.946 606.115 473.649 606.121 474.378Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.813 490.673C601.813 494.921 604.914 498.368 608.737 498.368C612.56 498.368 615.656 494.927 615.656 490.673V474.475C615.656 470.227 612.554 466.786 608.737 466.786C604.92 466.786 601.813 470.227 601.813 474.475V490.673Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.08 498.429H629.565V481.74C629.565 481.74 628.879 475.726 635.385 474.955C639.409 475.343 641.509 476.879 641.321 482.844C641.321 488.039 641.321 498.429 641.321 498.429H650.788V479.167C650.788 479.167 650.879 468.971 641.114 467.241C639.014 466.859 633.079 466.859 629.638 471.666V467.417H620.08V498.429Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip49_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1135.59 458.127C1149.47 472.012 1149.48 494.518 1135.6 508.395C1121.72 522.272 1099.22 522.267 1085.33 508.382C1071.45 494.496 1071.44 471.991 1085.32 458.114C1099.2 444.237 1121.7 444.241 1135.59 458.127Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090.35 474.378C1090.36 474.923 1090.52 475.455 1090.83 475.905C1091.14 476.356 1091.57 476.705 1092.08 476.909C1092.58 477.113 1093.14 477.162 1093.67 477.051C1094.21 476.939 1094.69 476.672 1095.08 476.283C1095.46 475.893 1095.72 475.4 1095.82 474.864C1095.92 474.328 1095.86 473.774 1095.64 473.273C1095.43 472.771 1095.07 472.345 1094.61 472.047C1094.16 471.749 1093.62 471.593 1093.08 471.599C1092.35 471.607 1091.65 471.904 1091.14 472.425C1090.63 472.946 1090.35 473.649 1090.35 474.378Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.04 490.673C1086.04 494.921 1089.15 498.368 1092.97 498.368C1096.79 498.368 1099.89 494.927 1099.89 490.673V474.475C1099.89 470.227 1096.79 466.786 1092.97 466.786C1089.15 466.786 1086.04 470.227 1086.04 474.475V490.673Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104.31 498.429H1113.8V481.74C1113.8 481.74 1113.11 475.726 1119.62 474.955C1123.64 475.343 1125.74 476.879 1125.55 482.844C1125.55 488.039 1125.55 498.429 1125.55 498.429H1135.02V479.167C1135.02 479.167 1135.11 468.971 1125.35 467.241C1123.25 466.859 1117.31 466.859 1113.87 471.666V467.417H1104.31V498.429Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip50_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1187.2 296.337C1187.2 296.883 1187.37 297.414 1187.68 297.865C1187.99 298.315 1188.42 298.664 1188.92 298.868C1189.43 299.072 1189.99 299.122 1190.52 299.01C1191.05 298.898 1191.54 298.631 1191.92 298.242C1192.3 297.853 1192.56 297.359 1192.66 296.823C1192.76 296.287 1192.7 295.734 1192.49 295.232C1192.28 294.731 1191.92 294.304 1191.46 294.006C1191 293.708 1190.47 293.552 1189.92 293.558C1189.2 293.566 1188.5 293.863 1187.99 294.384C1187.48 294.905 1187.19 295.608 1187.2 296.337Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1233.86 331.768C1248.52 317.109 1248.52 293.337 1233.85 278.672C1219.18 264.006 1195.41 264 1180.75 278.659C1166.09 293.317 1166.1 317.089 1180.77 331.755C1195.43 346.421 1219.2 346.426 1233.86 331.768ZM1182.89 312.632C1182.89 316.88 1185.99 320.327 1189.82 320.327C1193.64 320.327 1196.73 316.886 1196.73 312.632V296.434C1196.73 292.186 1193.63 288.745 1189.82 288.745C1186 288.745 1182.89 292.186 1182.89 296.434V312.632ZM1210.64 320.388H1201.16V289.376H1210.72V293.625C1214.16 288.818 1220.09 288.818 1222.19 289.2C1231.96 290.93 1231.87 301.126 1231.87 301.126V320.388H1222.4V304.803C1222.59 298.838 1220.49 297.302 1216.46 296.914C1209.96 297.685 1210.64 303.699 1210.64 303.699V320.388Z",
    fill: "#C4C4C4"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip51_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M651.357 369.107C665.242 382.992 665.247 405.498 651.37 419.374C637.493 433.251 614.987 433.247 601.102 419.362C587.216 405.476 587.212 382.971 601.089 369.094C614.966 355.217 637.471 355.221 651.357 369.107Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.121 385.358C606.126 385.903 606.293 386.435 606.6 386.885C606.907 387.336 607.34 387.685 607.846 387.889C608.352 388.093 608.906 388.142 609.44 388.031C609.974 387.919 610.462 387.652 610.844 387.262C611.226 386.873 611.483 386.379 611.584 385.844C611.685 385.308 611.625 384.754 611.411 384.253C611.197 383.751 610.839 383.324 610.383 383.026C609.926 382.728 609.391 382.573 608.846 382.579C608.117 382.587 607.42 382.884 606.909 383.405C606.398 383.926 606.115 384.628 606.121 385.358Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.813 401.653C601.813 405.901 604.914 409.348 608.737 409.348C612.56 409.348 615.656 405.907 615.656 401.653V385.455C615.656 381.207 612.554 377.766 608.737 377.766C604.92 377.766 601.813 381.207 601.813 385.455V401.653Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.08 409.409H629.565V392.719C629.565 392.719 628.879 386.705 635.385 385.934C639.409 386.323 641.509 387.858 641.321 393.824C641.321 399.019 641.321 409.409 641.321 409.409H650.788V390.146C650.788 390.146 650.879 379.951 641.114 378.221C639.014 377.839 633.079 377.839 629.638 382.645V378.397H620.08V409.409Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip52_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1329.28 369.107C1343.17 382.992 1343.17 405.498 1329.29 419.374C1315.42 433.251 1292.91 433.247 1279.03 419.362C1265.14 405.476 1265.14 382.971 1279.01 369.094C1292.89 355.217 1315.4 355.221 1329.28 369.107Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1284.05 385.358C1284.05 385.903 1284.22 386.435 1284.52 386.885C1284.83 387.336 1285.27 387.685 1285.77 387.889C1286.28 388.093 1286.83 388.142 1287.37 388.031C1287.9 387.919 1288.39 387.652 1288.77 387.262C1289.15 386.873 1289.41 386.379 1289.51 385.844C1289.61 385.308 1289.55 384.754 1289.34 384.253C1289.12 383.751 1288.76 383.324 1288.31 383.026C1287.85 382.728 1287.32 382.573 1286.77 382.579C1286.04 382.587 1285.34 382.884 1284.83 383.405C1284.32 383.926 1284.04 384.628 1284.05 385.358Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.74 401.653C1279.74 405.901 1282.84 409.348 1286.66 409.348C1290.49 409.348 1293.58 405.907 1293.58 401.653V385.455C1293.58 381.207 1290.48 377.766 1286.66 377.766C1282.84 377.766 1279.74 381.207 1279.74 385.455V401.653Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298 409.409H1307.49V392.719C1307.49 392.719 1306.8 386.705 1313.31 385.934C1317.33 386.323 1319.43 387.858 1319.25 393.824C1319.25 399.019 1319.25 409.409 1319.25 409.409H1328.71V390.146C1328.71 390.146 1328.8 379.951 1319.04 378.221C1316.94 377.839 1311 377.839 1307.56 382.645V378.397H1298V409.409Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip53_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M941.896 369.107C955.781 382.992 955.786 405.498 941.909 419.374C928.032 433.251 905.526 433.247 891.641 419.362C877.756 405.476 877.751 382.971 891.628 369.094C905.505 355.217 928.011 355.221 941.896 369.107Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.661 385.358C896.665 385.903 896.832 386.435 897.139 386.885C897.446 387.336 897.88 387.685 898.385 387.889C898.891 388.093 899.446 388.142 899.979 388.031C900.513 387.919 901.002 387.652 901.383 387.262C901.765 386.873 902.022 386.379 902.123 385.844C902.224 385.308 902.164 384.754 901.95 384.253C901.736 383.751 901.378 383.324 900.922 383.026C900.465 382.728 899.931 382.573 899.385 382.579C898.656 382.587 897.959 382.884 897.448 383.405C896.937 383.926 896.654 384.628 896.661 385.358Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.352 401.653C892.352 405.901 895.453 409.348 899.276 409.348C903.1 409.348 906.195 405.907 906.195 401.653V385.455C906.195 381.207 903.094 377.766 899.276 377.766C895.459 377.766 892.352 381.207 892.352 385.455V401.653Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.619 409.409H920.104V392.719C920.104 392.719 919.419 386.705 925.924 385.934C929.948 386.323 932.048 387.858 931.86 393.824C931.86 399.019 931.86 409.409 931.86 409.409H941.327V390.146C941.327 390.146 941.418 379.951 931.653 378.221C929.554 377.839 923.618 377.839 920.177 382.645V378.397H910.619V409.409Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip54_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.124 369.107C181.01 382.992 181.014 405.498 167.137 419.374C153.26 433.251 130.755 433.247 116.869 419.362C102.984 405.476 102.98 382.971 116.857 369.094C130.733 355.217 153.239 355.221 167.124 369.107Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.889 385.358C121.894 385.903 122.06 386.435 122.367 386.885C122.674 387.336 123.108 387.685 123.614 387.889C124.119 388.093 124.674 388.142 125.208 388.031C125.741 387.919 126.23 387.652 126.612 387.262C126.993 386.873 127.251 386.379 127.352 385.844C127.453 385.308 127.392 384.754 127.179 384.253C126.965 383.751 126.607 383.324 126.15 383.026C125.694 382.728 125.159 382.573 124.614 382.579C123.884 382.587 123.188 382.884 122.677 383.405C122.166 383.926 121.883 384.628 121.889 385.358Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.58 401.653C117.58 405.901 120.681 409.348 124.505 409.348C128.328 409.348 131.423 405.907 131.423 401.653V385.455C131.423 381.207 128.322 377.766 124.505 377.766C120.687 377.766 117.58 381.207 117.58 385.455V401.653Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.847 409.409H145.333V392.719C145.333 392.719 144.647 386.705 151.153 385.934C155.176 386.323 157.276 387.858 157.088 393.824C157.088 399.019 157.088 409.409 157.088 409.409H166.556V390.146C166.556 390.146 166.647 379.951 156.882 378.221C154.782 377.839 148.847 377.839 145.406 382.645V378.397H135.847V409.409Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip55_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M941.896 636.168C955.781 650.053 955.786 672.559 941.909 686.436C928.032 700.313 905.526 700.308 891.641 686.423C877.756 672.538 877.751 650.032 891.628 636.155C905.505 622.278 928.011 622.283 941.896 636.168Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.661 652.419C896.665 652.965 896.832 653.496 897.139 653.947C897.446 654.397 897.88 654.746 898.385 654.95C898.891 655.154 899.446 655.203 899.979 655.092C900.513 654.98 901.002 654.713 901.383 654.324C901.765 653.934 902.022 653.441 902.123 652.905C902.224 652.369 902.164 651.815 901.95 651.314C901.736 650.813 901.378 650.386 900.922 650.088C900.465 649.79 899.931 649.634 899.385 649.64C898.656 649.648 897.959 649.945 897.448 650.466C896.937 650.987 896.654 651.69 896.661 652.419Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.352 668.714C892.352 672.962 895.453 676.409 899.276 676.409C903.1 676.409 906.195 672.968 906.195 668.714V652.516C906.195 648.268 903.094 644.827 899.276 644.827C895.459 644.827 892.352 648.268 892.352 652.516V668.714Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.619 676.47H920.104V659.781C920.104 659.781 919.419 653.767 925.924 652.996C929.948 653.384 932.048 654.92 931.86 660.885C931.86 666.08 931.86 676.47 931.86 676.47H941.327V657.208C941.327 657.208 941.418 647.012 931.653 645.282C929.554 644.9 923.618 644.9 920.177 649.707V645.458H910.619V676.47Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip56_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1038.74 458.127C1052.63 472.012 1052.63 494.518 1038.76 508.395C1024.88 522.272 1002.37 522.267 988.487 508.382C974.602 494.496 974.598 471.991 988.475 458.114C1002.35 444.237 1024.86 444.241 1038.74 458.127Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.507 474.378C993.512 474.923 993.678 475.455 993.985 475.905C994.292 476.356 994.726 476.705 995.232 476.909C995.737 477.113 996.292 477.162 996.826 477.051C997.359 476.939 997.848 476.672 998.23 476.283C998.611 475.893 998.869 475.4 998.97 474.864C999.071 474.328 999.01 473.774 998.797 473.273C998.583 472.771 998.225 472.345 997.768 472.047C997.312 471.749 996.777 471.593 996.232 471.599C995.502 471.607 994.806 471.904 994.295 472.425C993.784 472.946 993.501 473.649 993.507 474.378Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.198 490.673C989.198 494.921 992.299 498.368 996.123 498.368C999.946 498.368 1003.04 494.927 1003.04 490.673V474.475C1003.04 470.227 999.94 466.786 996.123 466.786C992.305 466.786 989.198 470.227 989.198 474.475V490.673Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.47 498.429H1016.95V481.74C1016.95 481.74 1016.27 475.726 1022.77 474.955C1026.79 475.343 1028.89 476.879 1028.71 482.844C1028.71 488.039 1028.71 498.429 1028.71 498.429H1038.17V479.167C1038.17 479.167 1038.26 468.971 1028.5 467.241C1026.4 466.859 1020.46 466.859 1017.02 471.666V467.417H1007.47V498.429Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip57_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1135.59 191.066C1149.47 204.951 1149.48 227.457 1135.6 241.333C1121.72 255.21 1099.22 255.206 1085.33 241.321C1071.45 227.435 1071.44 204.93 1085.32 191.053C1099.2 177.176 1121.7 177.18 1135.59 191.066Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090.35 207.317C1090.36 207.862 1090.52 208.394 1090.83 208.844C1091.14 209.295 1091.57 209.644 1092.08 209.848C1092.58 210.052 1093.14 210.101 1093.67 209.99C1094.21 209.878 1094.69 209.611 1095.08 209.221C1095.46 208.832 1095.72 208.338 1095.82 207.803C1095.92 207.267 1095.86 206.713 1095.64 206.212C1095.43 205.71 1095.07 205.283 1094.61 204.985C1094.16 204.687 1093.62 204.532 1093.08 204.538C1092.35 204.546 1091.65 204.843 1091.14 205.364C1090.63 205.885 1090.35 206.587 1090.35 207.317Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.04 223.612C1086.04 227.86 1089.15 231.307 1092.97 231.307C1096.79 231.307 1099.89 227.866 1099.89 223.612V207.414C1099.89 203.166 1096.79 199.725 1092.97 199.725C1089.15 199.725 1086.04 203.166 1086.04 207.414V223.612Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104.31 231.368H1113.8V214.678C1113.8 214.678 1113.11 208.664 1119.62 207.893C1123.64 208.282 1125.74 209.817 1125.55 215.783C1125.55 220.978 1125.55 231.368 1125.55 231.368H1135.02V212.105C1135.02 212.105 1135.11 201.91 1125.35 200.18C1123.25 199.798 1117.31 199.798 1113.87 204.604V200.356H1104.31V231.368Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip58_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M748.203 191.066C762.088 204.951 762.093 227.457 748.216 241.333C734.339 255.21 711.833 255.206 697.948 241.321C684.063 227.435 684.058 204.93 697.935 191.053C711.812 177.176 734.318 177.18 748.203 191.066Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.968 207.317C702.972 207.862 703.139 208.394 703.446 208.844C703.753 209.295 704.187 209.644 704.692 209.848C705.198 210.052 705.753 210.101 706.286 209.99C706.82 209.878 707.309 209.611 707.69 209.221C708.072 208.832 708.33 208.338 708.43 207.803C708.531 207.267 708.471 206.713 708.257 206.212C708.043 205.71 707.685 205.283 707.229 204.985C706.772 204.687 706.238 204.532 705.693 204.538C704.963 204.546 704.266 204.843 703.755 205.364C703.244 205.885 702.961 206.587 702.968 207.317Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.659 223.612C698.659 227.86 701.76 231.307 705.583 231.307C709.407 231.307 712.502 227.866 712.502 223.612V207.414C712.502 203.166 709.401 199.725 705.583 199.725C701.766 199.725 698.659 203.166 698.659 207.414V223.612Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.926 231.368H726.412V214.678C726.412 214.678 725.726 208.664 732.231 207.893C736.255 208.282 738.355 209.817 738.167 215.783C738.167 220.978 738.167 231.368 738.167 231.368H747.634V212.105C747.634 212.105 747.725 201.91 737.96 200.18C735.861 199.798 729.925 199.798 726.484 204.604V200.356H716.926V231.368Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip59_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M651.357 191.066C665.242 204.951 665.247 227.457 651.37 241.333C637.493 255.21 614.987 255.206 601.102 241.321C587.216 227.435 587.212 204.93 601.089 191.053C614.966 177.176 637.471 177.18 651.357 191.066Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.121 207.317C606.126 207.862 606.293 208.394 606.6 208.844C606.907 209.295 607.34 209.644 607.846 209.848C608.352 210.052 608.906 210.101 609.44 209.99C609.974 209.878 610.462 209.611 610.844 209.221C611.226 208.832 611.483 208.338 611.584 207.803C611.685 207.267 611.625 206.713 611.411 206.212C611.197 205.71 610.839 205.283 610.383 204.985C609.926 204.687 609.391 204.532 608.846 204.538C608.117 204.546 607.42 204.843 606.909 205.364C606.398 205.885 606.115 206.587 606.121 207.317Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.813 223.612C601.813 227.86 604.914 231.307 608.737 231.307C612.56 231.307 615.656 227.866 615.656 223.612V207.414C615.656 203.166 612.554 199.725 608.737 199.725C604.92 199.725 601.813 203.166 601.813 207.414V223.612Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.08 231.368H629.565V214.678C629.565 214.678 628.879 208.664 635.385 207.893C639.409 208.282 641.509 209.817 641.321 215.783C641.321 220.978 641.321 231.368 641.321 231.368H650.788V212.105C650.788 212.105 650.879 201.91 641.114 200.18C639.014 199.798 633.079 199.798 629.638 204.604V200.356H620.08V231.368Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip60_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0426 296.337C25.0474 296.883 25.2139 297.414 25.5209 297.865C25.8279 298.315 26.2617 298.664 26.7673 298.868C27.2729 299.072 27.8277 299.122 28.3613 299.01C28.895 298.898 29.3836 298.631 29.7652 298.242C30.1469 297.853 30.4045 297.359 30.5054 296.823C30.6063 296.287 30.546 295.734 30.3321 295.232C30.1182 294.731 29.7604 294.304 29.3038 294.006C28.8473 293.708 28.3126 293.552 27.7675 293.558C27.0378 293.566 26.3411 293.863 25.8302 294.384C25.3194 294.905 25.0361 295.608 25.0426 296.337Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.705 331.768C86.3636 317.109 86.3578 293.337 71.6921 278.672C57.0264 264.006 33.2544 264 18.5958 278.659C3.93724 293.317 3.943 317.089 18.6087 331.755C33.2744 346.421 57.0464 346.426 71.705 331.768ZM20.7337 312.632C20.7337 316.88 23.8349 320.327 27.6583 320.327C31.4816 320.327 34.5767 316.886 34.5767 312.632V296.434C34.5767 292.186 31.4756 288.745 27.6583 288.745C23.841 288.745 20.7337 292.186 20.7337 296.434V312.632ZM48.4865 320.388H39.0009V289.376H48.5593V293.625C52.0003 288.818 57.9356 288.818 60.0354 289.2C69.8002 290.93 69.7091 301.126 69.7091 301.126V320.388H60.2418V304.803C60.4299 298.838 58.3301 297.302 54.3065 296.914C47.8007 297.685 48.4865 303.699 48.4865 303.699V320.388Z",
    fill: "#C4C4C4"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip61_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.124 191.066C181.01 204.951 181.014 227.457 167.137 241.333C153.26 255.21 130.755 255.206 116.869 241.321C102.984 227.435 102.98 204.93 116.857 191.053C130.733 177.176 153.239 177.18 167.124 191.066Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.889 207.317C121.894 207.862 122.06 208.394 122.367 208.844C122.674 209.295 123.108 209.644 123.614 209.848C124.119 210.052 124.674 210.101 125.208 209.99C125.741 209.878 126.23 209.611 126.612 209.221C126.993 208.832 127.251 208.338 127.352 207.803C127.453 207.267 127.392 206.713 127.179 206.212C126.965 205.71 126.607 205.283 126.15 204.985C125.694 204.687 125.159 204.532 124.614 204.538C123.884 204.546 123.188 204.843 122.677 205.364C122.166 205.885 121.883 206.587 121.889 207.317Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.58 223.612C117.58 227.86 120.681 231.307 124.505 231.307C128.328 231.307 131.423 227.866 131.423 223.612V207.414C131.423 203.166 128.322 199.725 124.505 199.725C120.687 199.725 117.58 203.166 117.58 207.414V223.612Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.847 231.368H145.333V214.678C145.333 214.678 144.647 208.664 151.153 207.893C155.176 208.282 157.276 209.817 157.088 215.783C157.088 220.978 157.088 231.368 157.088 231.368H166.556V212.105C166.556 212.105 166.647 201.91 156.882 200.18C154.782 199.798 148.847 199.798 145.406 204.604V200.356H135.847V231.368Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip62_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M554.51 636.168C568.396 650.053 568.4 672.559 554.523 686.436C540.646 700.313 518.141 700.308 504.255 686.423C490.37 672.538 490.366 650.032 504.242 636.155C518.119 622.278 540.625 622.283 554.51 636.168Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.275 652.419C509.28 652.965 509.446 653.496 509.753 653.947C510.06 654.397 510.494 654.746 511 654.95C511.505 655.154 512.06 655.203 512.594 655.092C513.127 654.98 513.616 654.713 513.998 654.324C514.379 653.934 514.637 653.441 514.738 652.905C514.839 652.369 514.778 651.815 514.564 651.314C514.351 650.813 513.993 650.386 513.536 650.088C513.08 649.79 512.545 649.634 512 649.64C511.27 649.648 510.573 649.945 510.063 650.466C509.552 650.987 509.268 651.69 509.275 652.419Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.966 668.714C504.966 672.962 508.067 676.409 511.891 676.409C515.714 676.409 518.809 672.968 518.809 668.714V652.516C518.809 648.268 515.708 644.827 511.891 644.827C508.073 644.827 504.966 648.268 504.966 652.516V668.714Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.233 676.47H532.719V659.781C532.719 659.781 532.033 653.767 538.539 652.996C542.562 653.384 544.662 654.92 544.474 660.885C544.474 666.08 544.474 676.47 544.474 676.47H553.941V657.208C553.941 657.208 554.032 647.012 544.268 645.282C542.168 644.9 536.233 644.9 532.792 649.707V645.458H523.233V676.47Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip63_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1232.44 102.045C1246.32 115.93 1246.33 138.436 1232.45 152.313C1218.57 166.19 1196.07 166.185 1182.18 152.3C1168.3 138.415 1168.29 115.909 1182.17 102.032C1196.04 88.1552 1218.55 88.1596 1232.44 102.045Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187.2 118.296C1187.2 118.842 1187.37 119.373 1187.68 119.824C1187.99 120.274 1188.42 120.623 1188.92 120.827C1189.43 121.031 1189.99 121.08 1190.52 120.969C1191.05 120.857 1191.54 120.59 1191.92 120.201C1192.3 119.812 1192.56 119.318 1192.66 118.782C1192.76 118.246 1192.7 117.693 1192.49 117.191C1192.28 116.69 1191.92 116.263 1191.46 115.965C1191 115.667 1190.47 115.511 1189.92 115.517C1189.2 115.525 1188.5 115.822 1187.99 116.343C1187.48 116.864 1187.19 117.567 1187.2 118.296Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1182.89 134.591C1182.89 138.839 1185.99 142.286 1189.82 142.286C1193.64 142.286 1196.73 138.845 1196.73 134.591V118.393C1196.73 114.145 1193.63 110.704 1189.82 110.704C1186 110.704 1182.89 114.145 1182.89 118.393V134.591Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.16 142.347H1210.64V125.658C1210.64 125.658 1209.96 119.644 1216.46 118.873C1220.49 119.261 1222.59 120.797 1222.4 126.762C1222.4 131.957 1222.4 142.347 1222.4 142.347H1231.87V123.085C1231.87 123.085 1231.96 112.889 1222.19 111.159C1220.09 110.777 1214.16 110.777 1210.72 115.584V111.335H1201.16V142.347Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip64_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M941.896 102.045C955.781 115.93 955.786 138.436 941.909 152.313C928.032 166.19 905.526 166.185 891.641 152.3C877.756 138.415 877.751 115.909 891.628 102.032C905.505 88.1552 928.011 88.1596 941.896 102.045Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.661 118.296C896.665 118.842 896.832 119.373 897.139 119.824C897.446 120.274 897.88 120.623 898.385 120.827C898.891 121.031 899.446 121.08 899.979 120.969C900.513 120.857 901.002 120.59 901.383 120.201C901.765 119.812 902.022 119.318 902.123 118.782C902.224 118.246 902.164 117.693 901.95 117.191C901.736 116.69 901.378 116.263 900.922 115.965C900.465 115.667 899.931 115.511 899.385 115.517C898.656 115.525 897.959 115.822 897.448 116.343C896.937 116.864 896.654 117.567 896.661 118.296Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.352 134.591C892.352 138.839 895.453 142.286 899.276 142.286C903.1 142.286 906.195 138.845 906.195 134.591V118.393C906.195 114.145 903.094 110.704 899.276 110.704C895.459 110.704 892.352 114.145 892.352 118.393V134.591Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.619 142.347H920.104V125.658C920.104 125.658 919.419 119.644 925.924 118.873C929.948 119.261 932.048 120.797 931.86 126.762C931.86 131.957 931.86 142.347 931.86 142.347H941.327V123.085C941.327 123.085 941.418 112.889 931.653 111.159C929.554 110.777 923.618 110.777 920.177 115.584V111.335H910.619V142.347Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip65_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M748.203 102.045C762.088 115.93 762.093 138.436 748.216 152.313C734.339 166.19 711.833 166.185 697.948 152.3C684.063 138.415 684.058 115.909 697.935 102.032C711.812 88.1552 734.318 88.1596 748.203 102.045Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.968 118.296C702.972 118.842 703.139 119.373 703.446 119.824C703.753 120.274 704.187 120.623 704.692 120.827C705.198 121.031 705.753 121.08 706.286 120.969C706.82 120.857 707.309 120.59 707.69 120.201C708.072 119.812 708.33 119.318 708.43 118.782C708.531 118.246 708.471 117.693 708.257 117.191C708.043 116.69 707.685 116.263 707.229 115.965C706.772 115.667 706.238 115.511 705.693 115.517C704.963 115.525 704.266 115.822 703.755 116.343C703.244 116.864 702.961 117.567 702.968 118.296Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.659 134.591C698.659 138.839 701.76 142.286 705.583 142.286C709.407 142.286 712.502 138.845 712.502 134.591V118.393C712.502 114.145 709.401 110.704 705.583 110.704C701.766 110.704 698.659 114.145 698.659 118.393V134.591Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.926 142.347H726.412V125.658C726.412 125.658 725.726 119.644 732.231 118.873C736.255 119.261 738.355 120.797 738.167 126.762C738.167 131.957 738.167 142.347 738.167 142.347H747.634V123.085C747.634 123.085 747.725 112.889 737.96 111.159C735.861 110.777 729.925 110.777 726.484 115.584V111.335H716.926V142.347Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip66_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M799.814 118.296C799.819 118.842 799.985 119.373 800.293 119.824C800.6 120.274 801.033 120.623 801.539 120.827C802.045 121.031 802.599 121.08 803.133 120.969C803.667 120.857 804.155 120.59 804.537 120.201C804.918 119.812 805.176 119.318 805.277 118.782C805.378 118.246 805.318 117.693 805.104 117.191C804.89 116.69 804.532 116.263 804.075 115.965C803.619 115.667 803.084 115.511 802.539 115.517C801.809 115.525 801.113 115.822 800.602 116.343C800.091 116.864 799.808 117.567 799.814 118.296Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M846.477 153.727C861.135 139.068 861.129 115.296 846.464 100.631C831.798 85.9649 808.026 85.9591 793.367 100.618C778.709 115.276 778.715 139.048 793.38 153.714C808.046 168.38 831.818 168.385 846.477 153.727ZM795.505 134.591C795.505 138.839 798.607 142.286 802.43 142.286C806.253 142.286 809.348 138.845 809.348 134.591V118.393C809.348 114.145 806.247 110.704 802.43 110.704C798.613 110.704 795.505 114.145 795.505 118.393V134.591ZM823.258 142.347H813.773V111.335H823.331V115.584C826.772 110.777 832.707 110.777 834.807 111.159C844.572 112.889 844.481 123.085 844.481 123.085V142.347H835.013V126.762C835.202 120.797 833.102 119.261 829.078 118.873C822.572 119.644 823.258 125.658 823.258 125.658V142.347Z",
    fill: "#C4C4C4"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip67_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.971 191.066C277.856 204.951 277.861 227.457 263.984 241.333C250.107 255.21 227.601 255.206 213.716 241.321C199.831 227.435 199.826 204.93 213.703 191.053C227.58 177.176 250.086 177.18 263.971 191.066Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.736 207.317C218.74 207.862 218.907 208.394 219.214 208.844C219.521 209.295 219.955 209.644 220.46 209.848C220.966 210.052 221.521 210.101 222.054 209.99C222.588 209.878 223.076 209.611 223.458 209.221C223.84 208.832 224.097 208.338 224.198 207.803C224.299 207.267 224.239 206.713 224.025 206.212C223.811 205.71 223.453 205.283 222.997 204.985C222.54 204.687 222.006 204.532 221.46 204.538C220.731 204.546 220.034 204.843 219.523 205.364C219.012 205.885 218.729 206.587 218.736 207.317Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.427 223.612C214.427 227.86 217.528 231.307 221.351 231.307C225.175 231.307 228.27 227.866 228.27 223.612V207.414C228.27 203.166 225.168 199.725 221.351 199.725C217.534 199.725 214.427 203.166 214.427 207.414V223.612Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.694 231.368H242.179V214.678C242.179 214.678 241.494 208.664 247.999 207.893C252.023 208.282 254.123 209.817 253.935 215.783C253.935 220.978 253.935 231.368 253.935 231.368H263.402V212.105C263.402 212.105 263.493 201.91 253.728 200.18C251.629 199.798 245.693 199.798 242.252 204.604V200.356H232.694V231.368Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip68_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.817 547.147C374.703 561.033 374.707 583.538 360.83 597.415C346.953 611.292 324.448 611.288 310.562 597.402C296.677 583.517 296.673 561.011 310.55 547.134C324.426 533.258 346.932 533.262 360.817 547.147Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.582 563.399C315.587 563.944 315.753 564.475 316.06 564.926C316.367 565.376 316.801 565.726 317.307 565.93C317.812 566.134 318.367 566.183 318.901 566.071C319.434 565.96 319.923 565.692 320.305 565.303C320.686 564.914 320.944 564.42 321.045 563.884C321.146 563.349 321.085 562.795 320.872 562.293C320.658 561.792 320.3 561.365 319.843 561.067C319.387 560.769 318.852 560.613 318.307 560.619C317.577 560.627 316.881 560.924 316.37 561.446C315.859 561.967 315.576 562.669 315.582 563.399Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.273 579.694C311.273 583.942 314.374 587.389 318.198 587.389C322.021 587.389 325.116 583.948 325.116 579.694V563.496C325.116 559.248 322.015 555.807 318.198 555.807C314.38 555.807 311.273 559.248 311.273 563.496V579.694Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.54 587.45H339.026V570.76C339.026 570.76 338.34 564.746 344.846 563.975C348.869 564.364 350.969 565.899 350.781 571.865C350.781 577.06 350.781 587.45 350.781 587.45H360.249V568.187C360.249 568.187 360.34 557.991 350.575 556.262C348.475 555.88 342.54 555.88 339.099 560.686V556.438H329.54V587.45Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip69_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.428 652.419C412.433 652.965 412.6 653.496 412.907 653.947C413.214 654.397 413.647 654.746 414.153 654.95C414.659 655.154 415.213 655.203 415.747 655.092C416.281 654.98 416.769 654.713 417.151 654.324C417.532 653.934 417.79 653.441 417.891 652.905C417.992 652.369 417.932 651.815 417.718 651.314C417.504 650.813 417.146 650.386 416.689 650.088C416.233 649.79 415.698 649.634 415.153 649.64C414.423 649.648 413.727 649.945 413.216 650.466C412.705 650.987 412.422 651.69 412.428 652.419Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M459.091 687.85C473.749 673.191 473.743 649.419 459.078 634.754C444.412 620.088 420.64 620.082 405.981 634.741C391.323 649.399 391.329 673.171 405.994 687.837C420.66 702.503 444.432 702.509 459.091 687.85ZM408.119 668.714C408.119 672.962 411.221 676.409 415.044 676.409C418.867 676.409 421.962 672.968 421.962 668.714V652.516C421.962 648.268 418.861 644.827 415.044 644.827C411.227 644.827 408.119 648.268 408.119 652.516V668.714ZM435.872 676.47H426.387V645.458H435.945V649.707C439.386 644.9 445.321 644.9 447.421 645.282C457.186 647.012 457.095 657.208 457.095 657.208V676.47H447.627V660.885C447.816 654.92 445.716 653.384 441.692 652.996C435.186 653.767 435.872 659.781 435.872 659.781V676.47Z",
    fill: "#C4C4C4"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip70_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M748.203 636.168C762.088 650.053 762.093 672.559 748.216 686.436C734.339 700.313 711.833 700.308 697.948 686.423C684.063 672.538 684.058 650.032 697.935 636.155C711.812 622.278 734.318 622.283 748.203 636.168Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.968 652.419C702.972 652.965 703.139 653.496 703.446 653.947C703.753 654.397 704.187 654.746 704.692 654.95C705.198 655.154 705.753 655.203 706.286 655.092C706.82 654.98 707.309 654.713 707.69 654.324C708.072 653.934 708.33 653.441 708.43 652.905C708.531 652.369 708.471 651.815 708.257 651.314C708.043 650.813 707.685 650.386 707.229 650.088C706.772 649.79 706.238 649.634 705.693 649.64C704.963 649.648 704.266 649.945 703.755 650.466C703.244 650.987 702.961 651.69 702.968 652.419Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.659 668.714C698.659 672.962 701.76 676.409 705.583 676.409C709.407 676.409 712.502 672.968 712.502 668.714V652.516C712.502 648.268 709.401 644.827 705.583 644.827C701.766 644.827 698.659 648.268 698.659 652.516V668.714Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.926 676.47H726.412V659.781C726.412 659.781 725.726 653.767 732.231 652.996C736.255 653.384 738.355 654.92 738.167 660.885C738.167 666.08 738.167 676.47 738.167 676.47H747.634V657.208C747.634 657.208 747.725 647.012 737.96 645.282C735.861 644.9 729.925 644.9 726.484 649.707V645.458H716.926V676.47Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip71_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.278 102.045C84.1633 115.93 84.1677 138.436 70.2909 152.313C56.414 166.19 33.9083 166.185 20.023 152.3C6.13771 138.415 6.13323 115.909 20.0101 102.032C33.887 88.1552 56.3927 88.1596 70.278 102.045Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0426 118.296C25.0474 118.842 25.2139 119.373 25.5209 119.824C25.8279 120.274 26.2617 120.623 26.7673 120.827C27.2729 121.031 27.8277 121.08 28.3613 120.969C28.895 120.857 29.3836 120.59 29.7652 120.201C30.1469 119.812 30.4045 119.318 30.5054 118.782C30.6063 118.246 30.546 117.693 30.3321 117.191C30.1182 116.69 29.7604 116.263 29.3038 115.965C28.8473 115.667 28.3126 115.511 27.7675 115.517C27.0378 115.525 26.3411 115.822 25.8302 116.343C25.3194 116.864 25.0361 117.567 25.0426 118.296Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7337 134.591C20.7337 138.839 23.8349 142.286 27.6582 142.286C31.4816 142.286 34.5767 138.845 34.5767 134.591V118.393C34.5767 114.145 31.4755 110.704 27.6582 110.704C23.8409 110.704 20.7337 114.145 20.7337 118.393V134.591Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0009 142.347H48.4864V125.658C48.4864 125.658 47.8006 119.644 54.3064 118.873C58.33 119.261 60.4299 120.797 60.2417 126.762C60.2417 131.957 60.2417 142.347 60.2417 142.347H69.7091V123.085C69.7091 123.085 69.8001 112.889 60.0354 111.159C57.9356 110.777 52.0003 110.777 48.5592 115.584V111.335H39.0009V142.347Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip72_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1038.74 547.147C1052.63 561.033 1052.63 583.538 1038.76 597.415C1024.88 611.292 1002.37 611.288 988.487 597.402C974.602 583.517 974.598 561.011 988.475 547.134C1002.35 533.258 1024.86 533.262 1038.74 547.147Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.507 563.399C993.512 563.944 993.678 564.475 993.985 564.926C994.292 565.376 994.726 565.726 995.232 565.93C995.737 566.134 996.292 566.183 996.826 566.071C997.359 565.96 997.848 565.692 998.23 565.303C998.611 564.914 998.869 564.42 998.97 563.884C999.071 563.349 999.01 562.795 998.797 562.293C998.583 561.792 998.225 561.365 997.768 561.067C997.312 560.769 996.777 560.613 996.232 560.619C995.502 560.627 994.806 560.924 994.295 561.446C993.784 561.967 993.501 562.669 993.507 563.399Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.198 579.694C989.198 583.942 992.299 587.389 996.123 587.389C999.946 587.389 1003.04 583.948 1003.04 579.694V563.496C1003.04 559.248 999.94 555.807 996.123 555.807C992.305 555.807 989.198 559.248 989.198 563.496V579.694Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.47 587.45H1016.95V570.76C1016.95 570.76 1016.27 564.746 1022.77 563.975C1026.79 564.364 1028.89 565.899 1028.71 571.865C1028.71 577.06 1028.71 587.45 1028.71 587.45H1038.17V568.187C1038.17 568.187 1038.26 557.991 1028.5 556.262C1026.4 555.88 1020.46 555.88 1017.02 560.686V556.438H1007.47V587.45Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip73_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1135.59 280.086C1149.47 293.971 1149.48 316.477 1135.6 330.354C1121.72 344.231 1099.22 344.226 1085.33 330.341C1071.45 316.456 1071.44 293.95 1085.32 280.073C1099.2 266.196 1121.7 266.201 1135.59 280.086Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090.35 296.337C1090.36 296.883 1090.52 297.414 1090.83 297.865C1091.14 298.315 1091.57 298.664 1092.08 298.868C1092.58 299.072 1093.14 299.122 1093.67 299.01C1094.21 298.898 1094.69 298.631 1095.08 298.242C1095.46 297.853 1095.72 297.359 1095.82 296.823C1095.92 296.287 1095.86 295.734 1095.64 295.232C1095.43 294.731 1095.07 294.304 1094.61 294.006C1094.16 293.708 1093.62 293.552 1093.08 293.558C1092.35 293.566 1091.65 293.863 1091.14 294.384C1090.63 294.905 1090.35 295.608 1090.35 296.337Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.04 312.632C1086.04 316.88 1089.15 320.327 1092.97 320.327C1096.79 320.327 1099.89 316.886 1099.89 312.632V296.434C1099.89 292.186 1096.79 288.745 1092.97 288.745C1089.15 288.745 1086.04 292.186 1086.04 296.434V312.632Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104.31 320.388H1113.8V303.699C1113.8 303.699 1113.11 297.685 1119.62 296.914C1123.64 297.302 1125.74 298.838 1125.55 304.803C1125.55 309.998 1125.55 320.388 1125.55 320.388H1135.02V301.126C1135.02 301.126 1135.11 290.93 1125.35 289.2C1123.25 288.818 1117.31 288.818 1113.87 293.625V289.377H1104.31V320.388Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip74_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M554.51 369.107C568.396 382.992 568.4 405.498 554.523 419.374C540.646 433.251 518.141 433.247 504.255 419.362C490.37 405.476 490.366 382.971 504.242 369.094C518.119 355.217 540.625 355.221 554.51 369.107Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.275 385.358C509.28 385.903 509.446 386.435 509.753 386.885C510.06 387.336 510.494 387.685 511 387.889C511.505 388.093 512.06 388.142 512.594 388.031C513.127 387.919 513.616 387.652 513.998 387.262C514.379 386.873 514.637 386.379 514.738 385.844C514.839 385.308 514.778 384.754 514.564 384.253C514.351 383.751 513.993 383.324 513.536 383.026C513.08 382.728 512.545 382.573 512 382.579C511.27 382.587 510.573 382.884 510.063 383.405C509.552 383.926 509.268 384.628 509.275 385.358Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.966 401.653C504.966 405.901 508.067 409.348 511.891 409.348C515.714 409.348 518.809 405.907 518.809 401.653V385.455C518.809 381.207 515.708 377.766 511.891 377.766C508.073 377.766 504.966 381.207 504.966 385.455V401.653Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.233 409.409H532.719V392.719C532.719 392.719 532.033 386.705 538.539 385.934C542.562 386.323 544.662 387.858 544.474 393.824C544.474 399.019 544.474 409.409 544.474 409.409H553.941V390.146C553.941 390.146 554.032 379.951 544.268 378.221C542.168 377.839 536.233 377.839 532.792 382.645V378.397H523.233V409.409Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip75_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M651.357 280.086C665.242 293.971 665.247 316.477 651.37 330.354C637.493 344.231 614.987 344.226 601.102 330.341C587.216 316.456 587.212 293.95 601.089 280.073C614.966 266.196 637.471 266.201 651.357 280.086Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.121 296.337C606.126 296.883 606.293 297.414 606.6 297.865C606.907 298.315 607.34 298.664 607.846 298.868C608.352 299.072 608.906 299.122 609.44 299.01C609.974 298.898 610.462 298.631 610.844 298.242C611.226 297.853 611.483 297.359 611.584 296.823C611.685 296.287 611.625 295.734 611.411 295.232C611.197 294.731 610.839 294.304 610.383 294.006C609.926 293.708 609.391 293.552 608.846 293.558C608.117 293.566 607.42 293.863 606.909 294.384C606.398 294.905 606.115 295.608 606.121 296.337Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.813 312.632C601.813 316.88 604.914 320.327 608.737 320.327C612.56 320.327 615.656 316.886 615.656 312.632V296.434C615.656 292.186 612.554 288.745 608.737 288.745C604.92 288.745 601.813 292.186 601.813 296.434V312.632Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.08 320.388H629.565V303.699C629.565 303.699 628.879 297.685 635.385 296.914C639.409 297.302 641.509 298.838 641.321 304.803C641.321 309.998 641.321 320.388 641.321 320.388H650.788V301.126C650.788 301.126 650.879 290.93 641.114 289.2C639.014 288.818 633.079 288.818 629.638 293.625V289.377H620.08V320.388Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip76_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1426.13 369.107C1440.01 382.992 1440.02 405.498 1426.14 419.374C1412.26 433.251 1389.76 433.247 1375.87 419.362C1361.99 405.476 1361.98 382.971 1375.86 369.094C1389.74 355.217 1412.24 355.221 1426.13 369.107Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380.89 385.358C1380.9 385.903 1381.06 386.435 1381.37 386.885C1381.68 387.336 1382.11 387.685 1382.62 387.889C1383.12 388.093 1383.68 388.142 1384.21 388.031C1384.75 387.919 1385.23 387.652 1385.62 387.262C1386 386.873 1386.25 386.379 1386.36 385.844C1386.46 385.308 1386.4 384.754 1386.18 384.253C1385.97 383.751 1385.61 383.324 1385.15 383.026C1384.7 382.728 1384.16 382.573 1383.62 382.579C1382.89 382.587 1382.19 382.884 1381.68 383.405C1381.17 383.926 1380.89 384.628 1380.89 385.358Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.58 401.653C1376.58 405.901 1379.69 409.348 1383.51 409.348C1387.33 409.348 1390.43 405.907 1390.43 401.653V385.455C1390.43 381.207 1387.33 377.766 1383.51 377.766C1379.69 377.766 1376.58 381.207 1376.58 385.455V401.653Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1394.85 409.409H1404.34V392.719C1404.34 392.719 1403.65 386.705 1410.16 385.934C1414.18 386.323 1416.28 387.858 1416.09 393.824C1416.09 399.019 1416.09 409.409 1416.09 409.409H1425.56V390.146C1425.56 390.146 1425.65 379.951 1415.89 378.221C1413.79 377.839 1407.85 377.839 1404.41 382.645V378.397H1394.85V409.409Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip77_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.124 280.086C181.01 293.971 181.014 316.477 167.137 330.354C153.26 344.231 130.755 344.226 116.869 330.341C102.984 316.456 102.98 293.95 116.857 280.073C130.733 266.196 153.239 266.201 167.124 280.086Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.889 296.337C121.894 296.883 122.06 297.414 122.367 297.865C122.674 298.315 123.108 298.664 123.614 298.868C124.119 299.072 124.674 299.122 125.208 299.01C125.741 298.898 126.23 298.631 126.612 298.242C126.993 297.853 127.251 297.359 127.352 296.823C127.453 296.287 127.392 295.734 127.179 295.232C126.965 294.731 126.607 294.304 126.15 294.006C125.694 293.708 125.159 293.552 124.614 293.558C123.884 293.566 123.188 293.863 122.677 294.384C122.166 294.905 121.883 295.608 121.889 296.337Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.58 312.632C117.58 316.88 120.681 320.327 124.505 320.327C128.328 320.327 131.423 316.886 131.423 312.632V296.434C131.423 292.186 128.322 288.745 124.505 288.745C120.687 288.745 117.58 292.186 117.58 296.434V312.632Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.847 320.388H145.333V303.699C145.333 303.699 144.647 297.685 151.153 296.914C155.176 297.302 157.276 298.838 157.088 304.803C157.088 309.998 157.088 320.388 157.088 320.388H166.556V301.126C166.556 301.126 166.647 290.93 156.882 289.2C154.782 288.818 148.847 288.818 145.406 293.625V289.377H135.847V320.388Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip78_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.817 636.168C374.703 650.053 374.707 672.559 360.83 686.436C346.953 700.313 324.448 700.308 310.562 686.423C296.677 672.538 296.673 650.032 310.55 636.155C324.426 622.278 346.932 622.283 360.817 636.168Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.582 652.419C315.587 652.965 315.753 653.496 316.06 653.947C316.367 654.397 316.801 654.746 317.307 654.95C317.812 655.154 318.367 655.203 318.901 655.092C319.434 654.98 319.923 654.713 320.305 654.324C320.686 653.934 320.944 653.441 321.045 652.905C321.146 652.369 321.085 651.815 320.872 651.314C320.658 650.813 320.3 650.386 319.843 650.088C319.387 649.79 318.852 649.634 318.307 649.64C317.577 649.648 316.881 649.945 316.37 650.466C315.859 650.987 315.576 651.69 315.582 652.419Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.273 668.714C311.273 672.962 314.374 676.409 318.198 676.409C322.021 676.409 325.116 672.968 325.116 668.714V652.516C325.116 648.268 322.015 644.827 318.198 644.827C314.38 644.827 311.273 648.268 311.273 652.516V668.714Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.54 676.47H339.026V659.781C339.026 659.781 338.34 653.767 344.846 652.996C348.869 653.384 350.969 654.92 350.781 660.885C350.781 666.08 350.781 676.47 350.781 676.47H360.249V657.208C360.249 657.208 360.34 647.012 350.575 645.282C348.475 644.9 342.54 644.9 339.099 649.707V645.458H329.54V676.47Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip79_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1038.74 280.086C1052.63 293.971 1052.63 316.477 1038.76 330.354C1024.88 344.231 1002.37 344.226 988.487 330.341C974.602 316.456 974.598 293.95 988.475 280.073C1002.35 266.196 1024.86 266.201 1038.74 280.086Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.507 296.337C993.512 296.883 993.678 297.414 993.985 297.865C994.292 298.315 994.726 298.664 995.232 298.868C995.737 299.072 996.292 299.122 996.826 299.01C997.359 298.898 997.848 298.631 998.23 298.242C998.611 297.853 998.869 297.359 998.97 296.823C999.071 296.287 999.01 295.734 998.797 295.232C998.583 294.731 998.225 294.304 997.768 294.006C997.312 293.708 996.777 293.552 996.232 293.558C995.502 293.566 994.806 293.863 994.295 294.384C993.784 294.905 993.501 295.608 993.507 296.337Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.198 312.632C989.198 316.88 992.299 320.327 996.123 320.327C999.946 320.327 1003.04 316.886 1003.04 312.632V296.434C1003.04 292.186 999.94 288.745 996.123 288.745C992.305 288.745 989.198 292.186 989.198 296.434V312.632Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.47 320.388H1016.95V303.699C1016.95 303.699 1016.27 297.685 1022.77 296.914C1026.79 297.302 1028.89 298.838 1028.71 304.803C1028.71 309.998 1028.71 320.388 1028.71 320.388H1038.17V301.126C1038.17 301.126 1038.26 290.93 1028.5 289.2C1026.4 288.818 1020.46 288.818 1017.02 293.625V289.377H1007.47V320.388Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip80_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M554.51 280.086C568.396 293.971 568.4 316.477 554.523 330.354C540.646 344.231 518.141 344.226 504.255 330.341C490.37 316.456 490.366 293.95 504.242 280.073C518.119 266.196 540.625 266.201 554.51 280.086Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.275 296.337C509.28 296.883 509.446 297.414 509.753 297.865C510.06 298.315 510.494 298.664 511 298.868C511.505 299.072 512.06 299.122 512.594 299.01C513.127 298.898 513.616 298.631 513.998 298.242C514.379 297.853 514.637 297.359 514.738 296.823C514.839 296.287 514.778 295.734 514.564 295.232C514.351 294.731 513.993 294.304 513.536 294.006C513.08 293.708 512.545 293.552 512 293.558C511.27 293.566 510.573 293.863 510.063 294.384C509.552 294.905 509.268 295.608 509.275 296.337Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.966 312.632C504.966 316.88 508.067 320.327 511.891 320.327C515.714 320.327 518.809 316.886 518.809 312.632V296.434C518.809 292.186 515.708 288.745 511.891 288.745C508.073 288.745 504.966 292.186 504.966 296.434V312.632Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.233 320.388H532.719V303.699C532.719 303.699 532.033 297.685 538.539 296.914C542.562 297.302 544.662 298.838 544.474 304.803C544.474 309.998 544.474 320.388 544.474 320.388H553.941V301.126C553.941 301.126 554.032 290.93 544.268 289.2C542.168 288.818 536.233 288.818 532.792 293.625V289.377H523.233V320.388Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip81_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1426.13 191.066C1440.01 204.951 1440.02 227.457 1426.14 241.333C1412.26 255.21 1389.76 255.206 1375.87 241.321C1361.99 227.435 1361.98 204.93 1375.86 191.053C1389.74 177.176 1412.24 177.18 1426.13 191.066Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380.89 207.317C1380.9 207.862 1381.06 208.394 1381.37 208.844C1381.68 209.295 1382.11 209.644 1382.62 209.848C1383.12 210.052 1383.68 210.101 1384.21 209.99C1384.75 209.878 1385.23 209.611 1385.62 209.221C1386 208.832 1386.25 208.338 1386.36 207.803C1386.46 207.267 1386.4 206.713 1386.18 206.212C1385.97 205.71 1385.61 205.283 1385.15 204.985C1384.7 204.687 1384.16 204.532 1383.62 204.538C1382.89 204.546 1382.19 204.843 1381.68 205.364C1381.17 205.885 1380.89 206.587 1380.89 207.317Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.58 223.612C1376.58 227.86 1379.69 231.307 1383.51 231.307C1387.33 231.307 1390.43 227.866 1390.43 223.612V207.414C1390.43 203.166 1387.33 199.725 1383.51 199.725C1379.69 199.725 1376.58 203.166 1376.58 207.414V223.612Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1394.85 231.368H1404.34V214.678C1404.34 214.678 1403.65 208.664 1410.16 207.893C1414.18 208.282 1416.28 209.817 1416.09 215.783C1416.09 220.978 1416.09 231.368 1416.09 231.368H1425.56V212.105C1425.56 212.105 1425.65 201.91 1415.89 200.18C1413.79 199.798 1407.85 199.798 1404.41 204.604V200.356H1394.85V231.368Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip82_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.664 280.086C471.549 293.971 471.553 316.477 457.676 330.354C443.8 344.231 421.294 344.226 407.409 330.341C393.523 316.456 393.519 293.95 407.396 280.073C421.273 266.196 443.778 266.201 457.664 280.086Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.428 296.337C412.433 296.883 412.6 297.414 412.907 297.865C413.214 298.315 413.647 298.664 414.153 298.868C414.659 299.072 415.213 299.122 415.747 299.01C416.281 298.898 416.769 298.631 417.151 298.242C417.532 297.853 417.79 297.359 417.891 296.823C417.992 296.287 417.932 295.734 417.718 295.232C417.504 294.731 417.146 294.304 416.689 294.006C416.233 293.708 415.698 293.552 415.153 293.558C414.423 293.566 413.727 293.863 413.216 294.384C412.705 294.905 412.422 295.608 412.428 296.337Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.119 312.632C408.119 316.88 411.22 320.327 415.044 320.327C418.867 320.327 421.962 316.886 421.962 312.632V296.434C421.962 292.186 418.861 288.745 415.044 288.745C411.227 288.745 408.119 292.186 408.119 296.434V312.632Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.387 320.388H435.872V303.699C435.872 303.699 435.186 297.685 441.692 296.914C445.716 297.302 447.816 298.838 447.627 304.803C447.627 309.998 447.627 320.388 447.627 320.388H457.095V301.126C457.095 301.126 457.186 290.93 447.421 289.2C445.321 288.818 439.386 288.818 435.945 293.625V289.377H426.387V320.388Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip83_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1329.28 280.086C1343.17 293.971 1343.17 316.477 1329.29 330.354C1315.42 344.231 1292.91 344.226 1279.03 330.341C1265.14 316.456 1265.14 293.95 1279.01 280.073C1292.89 266.196 1315.4 266.201 1329.28 280.086Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1284.05 296.337C1284.05 296.883 1284.22 297.414 1284.52 297.865C1284.83 298.315 1285.27 298.664 1285.77 298.868C1286.28 299.072 1286.83 299.122 1287.37 299.01C1287.9 298.898 1288.39 298.631 1288.77 298.242C1289.15 297.853 1289.41 297.359 1289.51 296.823C1289.61 296.287 1289.55 295.734 1289.34 295.232C1289.12 294.731 1288.76 294.304 1288.31 294.006C1287.85 293.708 1287.32 293.552 1286.77 293.558C1286.04 293.566 1285.34 293.863 1284.83 294.384C1284.32 294.905 1284.04 295.608 1284.05 296.337Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.74 312.632C1279.74 316.88 1282.84 320.327 1286.66 320.327C1290.49 320.327 1293.58 316.886 1293.58 312.632V296.434C1293.58 292.186 1290.48 288.745 1286.66 288.745C1282.84 288.745 1279.74 292.186 1279.74 296.434V312.632Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298 320.388H1307.49V303.699C1307.49 303.699 1306.8 297.685 1313.31 296.914C1317.33 297.302 1319.43 298.838 1319.25 304.803C1319.25 309.998 1319.25 320.388 1319.25 320.388H1328.71V301.126C1328.71 301.126 1328.8 290.93 1319.04 289.2C1316.94 288.818 1311 288.818 1307.56 293.625V289.377H1298V320.388Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip84_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.124 636.168C181.01 650.053 181.014 672.559 167.137 686.436C153.26 700.313 130.755 700.308 116.869 686.423C102.984 672.538 102.98 650.032 116.857 636.155C130.733 622.278 153.239 622.283 167.124 636.168Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.889 652.419C121.894 652.965 122.06 653.496 122.367 653.947C122.674 654.397 123.108 654.746 123.614 654.95C124.119 655.154 124.674 655.203 125.208 655.092C125.741 654.98 126.23 654.713 126.612 654.324C126.993 653.934 127.251 653.441 127.352 652.905C127.453 652.369 127.392 651.815 127.179 651.314C126.965 650.813 126.607 650.386 126.15 650.088C125.694 649.79 125.159 649.634 124.614 649.64C123.884 649.648 123.188 649.945 122.677 650.466C122.166 650.987 121.883 651.69 121.889 652.419Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.58 668.714C117.58 672.962 120.681 676.409 124.505 676.409C128.328 676.409 131.423 672.968 131.423 668.714V652.516C131.423 648.268 128.322 644.827 124.505 644.827C120.687 644.827 117.58 648.268 117.58 652.516V668.714Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.847 676.47H145.333V659.781C145.333 659.781 144.647 653.767 151.153 652.996C155.176 653.384 157.276 654.92 157.088 660.885C157.088 666.08 157.088 676.47 157.088 676.47H166.556V657.208C166.556 657.208 166.647 647.012 156.882 645.282C154.782 644.9 148.847 644.9 145.406 649.707V645.458H135.847V676.47Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip85_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1232.44 369.107C1246.32 382.992 1246.33 405.498 1232.45 419.374C1218.57 433.251 1196.07 433.247 1182.18 419.362C1168.3 405.476 1168.29 382.971 1182.17 369.094C1196.04 355.217 1218.55 355.221 1232.44 369.107Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187.2 385.358C1187.2 385.903 1187.37 386.435 1187.68 386.885C1187.99 387.336 1188.42 387.685 1188.92 387.889C1189.43 388.093 1189.99 388.142 1190.52 388.031C1191.05 387.919 1191.54 387.652 1191.92 387.262C1192.3 386.873 1192.56 386.379 1192.66 385.844C1192.76 385.308 1192.7 384.754 1192.49 384.253C1192.28 383.751 1191.92 383.324 1191.46 383.026C1191 382.728 1190.47 382.573 1189.92 382.579C1189.2 382.587 1188.5 382.884 1187.99 383.405C1187.48 383.926 1187.19 384.628 1187.2 385.358Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1182.89 401.653C1182.89 405.901 1185.99 409.348 1189.82 409.348C1193.64 409.348 1196.73 405.907 1196.73 401.653V385.455C1196.73 381.207 1193.63 377.766 1189.82 377.766C1186 377.766 1182.89 381.207 1182.89 385.455V401.653Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.16 409.409H1210.64V392.719C1210.64 392.719 1209.96 386.705 1216.46 385.934C1220.49 386.323 1222.59 387.858 1222.4 393.824C1222.4 399.019 1222.4 409.409 1222.4 409.409H1231.87V390.146C1231.87 390.146 1231.96 379.951 1222.19 378.221C1220.09 377.839 1214.16 377.839 1210.72 382.645V378.397H1201.16V409.409Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip86_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.817 458.127C374.703 472.012 374.707 494.518 360.83 508.395C346.953 522.272 324.448 522.267 310.562 508.382C296.677 494.496 296.673 471.991 310.55 458.114C324.426 444.237 346.932 444.241 360.817 458.127Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.582 474.378C315.587 474.923 315.753 475.455 316.06 475.905C316.367 476.356 316.801 476.705 317.307 476.909C317.812 477.113 318.367 477.162 318.901 477.051C319.434 476.939 319.923 476.672 320.305 476.283C320.686 475.893 320.944 475.4 321.045 474.864C321.146 474.328 321.085 473.774 320.872 473.273C320.658 472.771 320.3 472.345 319.843 472.047C319.387 471.749 318.852 471.593 318.307 471.599C317.577 471.607 316.881 471.904 316.37 472.425C315.859 472.946 315.576 473.649 315.582 474.378Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.273 490.673C311.273 494.921 314.374 498.368 318.198 498.368C322.021 498.368 325.116 494.927 325.116 490.673V474.475C325.116 470.227 322.015 466.786 318.198 466.786C314.38 466.786 311.273 470.227 311.273 474.475V490.673Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.54 498.429H339.026V481.74C339.026 481.74 338.34 475.726 344.846 474.955C348.869 475.343 350.969 476.879 350.781 482.844C350.781 488.039 350.781 498.429 350.781 498.429H360.249V479.167C360.249 479.167 360.34 468.971 350.575 467.241C348.475 466.859 342.54 466.859 339.099 471.666V467.417H329.54V498.429Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip87_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1038.74 102.045C1052.63 115.93 1052.63 138.436 1038.76 152.313C1024.88 166.19 1002.37 166.185 988.487 152.3C974.602 138.415 974.598 115.909 988.475 102.032C1002.35 88.1552 1024.86 88.1596 1038.74 102.045Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.507 118.296C993.512 118.842 993.678 119.373 993.985 119.824C994.292 120.274 994.726 120.623 995.232 120.827C995.737 121.031 996.292 121.08 996.826 120.969C997.359 120.857 997.848 120.59 998.23 120.201C998.611 119.812 998.869 119.318 998.97 118.782C999.071 118.246 999.01 117.693 998.797 117.191C998.583 116.69 998.225 116.263 997.768 115.965C997.312 115.667 996.777 115.511 996.232 115.517C995.502 115.525 994.806 115.822 994.295 116.343C993.784 116.864 993.501 117.567 993.507 118.296Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.198 134.591C989.198 138.839 992.299 142.286 996.123 142.286C999.946 142.286 1003.04 138.845 1003.04 134.591V118.393C1003.04 114.145 999.94 110.704 996.123 110.704C992.305 110.704 989.198 114.145 989.198 118.393V134.591Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.47 142.347H1016.95V125.658C1016.95 125.658 1016.27 119.644 1022.77 118.873C1026.79 119.261 1028.89 120.797 1028.71 126.762C1028.71 131.957 1028.71 142.347 1028.71 142.347H1038.17V123.085C1038.17 123.085 1038.26 112.889 1028.5 111.159C1026.4 110.777 1020.46 110.777 1017.02 115.584V111.335H1007.47V142.347Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip88_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.664 102.045C471.549 115.93 471.553 138.436 457.676 152.313C443.8 166.19 421.294 166.185 407.409 152.3C393.523 138.415 393.519 115.909 407.396 102.032C421.273 88.1552 443.778 88.1596 457.664 102.045Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.428 118.296C412.433 118.842 412.6 119.373 412.907 119.824C413.214 120.274 413.647 120.623 414.153 120.827C414.659 121.031 415.213 121.08 415.747 120.969C416.281 120.857 416.769 120.59 417.151 120.201C417.532 119.812 417.79 119.318 417.891 118.782C417.992 118.246 417.932 117.693 417.718 117.191C417.504 116.69 417.146 116.263 416.689 115.965C416.233 115.667 415.698 115.511 415.153 115.517C414.423 115.525 413.727 115.822 413.216 116.343C412.705 116.864 412.422 117.567 412.428 118.296Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.119 134.591C408.119 138.839 411.22 142.286 415.044 142.286C418.867 142.286 421.962 138.845 421.962 134.591V118.393C421.962 114.145 418.861 110.704 415.044 110.704C411.227 110.704 408.119 114.145 408.119 118.393V134.591Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.387 142.347H435.872V125.658C435.872 125.658 435.186 119.644 441.692 118.873C445.716 119.261 447.816 120.797 447.627 126.762C447.627 131.957 447.627 142.347 447.627 142.347H457.095V123.085C457.095 123.085 457.186 112.889 447.421 111.159C445.321 110.777 439.386 110.777 435.945 115.584V111.335H426.387V142.347Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip89_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1426.13 102.045C1440.01 115.93 1440.02 138.436 1426.14 152.313C1412.26 166.19 1389.76 166.185 1375.87 152.3C1361.99 138.415 1361.98 115.909 1375.86 102.032C1389.74 88.1552 1412.24 88.1596 1426.13 102.045Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380.89 118.296C1380.9 118.842 1381.06 119.373 1381.37 119.824C1381.68 120.274 1382.11 120.623 1382.62 120.827C1383.12 121.031 1383.68 121.08 1384.21 120.969C1384.75 120.857 1385.23 120.59 1385.62 120.201C1386 119.812 1386.25 119.318 1386.36 118.782C1386.46 118.246 1386.4 117.693 1386.18 117.191C1385.97 116.69 1385.61 116.263 1385.15 115.965C1384.7 115.667 1384.16 115.511 1383.62 115.517C1382.89 115.525 1382.19 115.822 1381.68 116.343C1381.17 116.864 1380.89 117.567 1380.89 118.296Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.58 134.591C1376.58 138.839 1379.69 142.286 1383.51 142.286C1387.33 142.286 1390.43 138.845 1390.43 134.591V118.393C1390.43 114.145 1387.33 110.704 1383.51 110.704C1379.69 110.704 1376.58 114.145 1376.58 118.393V134.591Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1394.85 142.347H1404.34V125.658C1404.34 125.658 1403.65 119.644 1410.16 118.873C1414.18 119.261 1416.28 120.797 1416.09 126.762C1416.09 131.957 1416.09 142.347 1416.09 142.347H1425.56V123.085C1425.56 123.085 1425.65 112.889 1415.89 111.159C1413.79 110.777 1407.85 110.777 1404.41 115.584V111.335H1394.85V142.347Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip90_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.664 191.066C471.549 204.951 471.553 227.457 457.676 241.333C443.8 255.21 421.294 255.206 407.409 241.321C393.523 227.435 393.519 204.93 407.396 191.053C421.273 177.176 443.778 177.18 457.664 191.066Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.428 207.317C412.433 207.862 412.6 208.394 412.907 208.844C413.214 209.295 413.647 209.644 414.153 209.848C414.659 210.052 415.213 210.101 415.747 209.99C416.281 209.878 416.769 209.611 417.151 209.221C417.532 208.832 417.79 208.338 417.891 207.803C417.992 207.267 417.932 206.713 417.718 206.212C417.504 205.71 417.146 205.283 416.689 204.985C416.233 204.687 415.698 204.532 415.153 204.538C414.423 204.546 413.727 204.843 413.216 205.364C412.705 205.885 412.422 206.587 412.428 207.317Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.119 223.612C408.119 227.86 411.22 231.307 415.044 231.307C418.867 231.307 421.962 227.866 421.962 223.612V207.414C421.962 203.166 418.861 199.725 415.044 199.725C411.227 199.725 408.119 203.166 408.119 207.414V223.612Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.387 231.368H435.872V214.678C435.872 214.678 435.186 208.664 441.692 207.893C445.716 208.282 447.816 209.817 447.627 215.783C447.627 220.978 447.627 231.368 447.627 231.368H457.095V212.105C457.095 212.105 457.186 201.91 447.421 200.18C445.321 199.798 439.386 199.798 435.945 204.604V200.356H426.387V231.368Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip91_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1284.05 118.296C1284.05 118.842 1284.22 119.373 1284.52 119.824C1284.83 120.274 1285.27 120.623 1285.77 120.827C1286.28 121.031 1286.83 121.08 1287.37 120.969C1287.9 120.857 1288.39 120.59 1288.77 120.201C1289.15 119.812 1289.41 119.318 1289.51 118.782C1289.61 118.246 1289.55 117.693 1289.34 117.191C1289.12 116.69 1288.76 116.263 1288.31 115.965C1287.85 115.667 1287.32 115.511 1286.77 115.517C1286.04 115.525 1285.34 115.822 1284.83 116.343C1284.32 116.864 1284.04 117.567 1284.05 118.296Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1330.71 153.727C1345.37 139.068 1345.36 115.296 1330.7 100.631C1316.03 85.9649 1292.26 85.9591 1277.6 100.618C1262.94 115.276 1262.95 139.048 1277.61 153.714C1292.28 168.38 1316.05 168.385 1330.71 153.727ZM1279.74 134.591C1279.74 138.839 1282.84 142.286 1286.66 142.286C1290.49 142.286 1293.58 138.845 1293.58 134.591V118.393C1293.58 114.145 1290.48 110.704 1286.66 110.704C1282.84 110.704 1279.74 114.145 1279.74 118.393V134.591ZM1307.49 142.347H1298V111.335H1307.56V115.584C1311 110.777 1316.94 110.777 1319.04 111.159C1328.8 112.889 1328.71 123.085 1328.71 123.085V142.347H1319.25V126.762C1319.43 120.797 1317.33 119.261 1313.31 118.873C1306.8 119.644 1307.49 125.658 1307.49 125.658V142.347Z",
    fill: "#C4C4C4"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip92_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.124 547.147C181.01 561.033 181.014 583.538 167.137 597.415C153.26 611.292 130.755 611.288 116.869 597.402C102.984 583.517 102.98 561.011 116.857 547.134C130.733 533.258 153.239 533.262 167.124 547.147Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.889 563.399C121.894 563.944 122.06 564.475 122.367 564.926C122.674 565.376 123.108 565.726 123.614 565.93C124.119 566.134 124.674 566.183 125.208 566.071C125.741 565.96 126.23 565.692 126.612 565.303C126.993 564.914 127.251 564.42 127.352 563.884C127.453 563.349 127.392 562.795 127.179 562.293C126.965 561.792 126.607 561.365 126.15 561.067C125.694 560.769 125.159 560.613 124.614 560.619C123.884 560.627 123.188 560.924 122.677 561.446C122.166 561.967 121.883 562.669 121.889 563.399Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.58 579.694C117.58 583.942 120.681 587.389 124.505 587.389C128.328 587.389 131.423 583.948 131.423 579.694V563.496C131.423 559.248 128.322 555.807 124.505 555.807C120.687 555.807 117.58 559.248 117.58 563.496V579.694Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.847 587.45H145.333V570.76C145.333 570.76 144.647 564.746 151.153 563.975C155.176 564.364 157.276 565.899 157.088 571.865C157.088 577.06 157.088 587.45 157.088 587.45H166.556V568.187C166.556 568.187 166.647 557.991 156.882 556.262C154.782 555.88 148.847 555.88 145.406 560.686V556.438H135.847V587.45Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip93_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.817 280.086C374.703 293.971 374.707 316.477 360.83 330.354C346.953 344.231 324.448 344.226 310.562 330.341C296.677 316.456 296.673 293.95 310.55 280.073C324.426 266.196 346.932 266.201 360.817 280.086Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.582 296.337C315.587 296.883 315.753 297.414 316.06 297.865C316.367 298.315 316.801 298.664 317.307 298.868C317.812 299.072 318.367 299.122 318.901 299.01C319.434 298.898 319.923 298.631 320.305 298.242C320.686 297.853 320.944 297.359 321.045 296.823C321.146 296.287 321.085 295.734 320.872 295.232C320.658 294.731 320.3 294.304 319.843 294.006C319.387 293.708 318.852 293.552 318.307 293.558C317.577 293.566 316.881 293.863 316.37 294.384C315.859 294.905 315.576 295.608 315.582 296.337Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.273 312.632C311.273 316.88 314.374 320.327 318.198 320.327C322.021 320.327 325.116 316.886 325.116 312.632V296.434C325.116 292.186 322.015 288.745 318.198 288.745C314.38 288.745 311.273 292.186 311.273 296.434V312.632Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.54 320.388H339.026V303.699C339.026 303.699 338.34 297.685 344.846 296.914C348.869 297.302 350.969 298.838 350.781 304.803C350.781 309.998 350.781 320.388 350.781 320.388H360.249V301.126C360.249 301.126 360.34 290.93 350.575 289.2C348.475 288.818 342.54 288.818 339.099 293.625V289.377H329.54V320.388Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip94_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1038.74 13.0245C1052.63 26.9098 1052.63 49.4155 1038.76 63.2924C1024.88 77.1693 1002.37 77.1648 988.487 63.2795C974.602 49.3942 974.598 26.8886 988.475 13.0117C1002.35 -0.865213 1024.86 -0.860742 1038.74 13.0245Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.507 29.276C993.512 29.8212 993.678 30.3527 993.985 30.8032C994.292 31.2537 994.726 31.603 995.232 31.8069C995.737 32.0108 996.292 32.0601 996.826 31.9486C997.359 31.8371 997.848 31.5697 998.23 31.1804C998.611 30.7911 998.869 30.2973 998.97 29.7616C999.071 29.2258 999.01 28.6722 998.797 28.1707C998.583 27.6692 998.225 27.2425 997.768 26.9444C997.312 26.6464 996.777 26.4905 996.232 26.4965C995.502 26.5045 994.806 26.8017 994.295 27.3228C993.784 27.8439 993.501 28.5463 993.507 29.276Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.198 45.5707C989.198 49.8189 992.299 53.266 996.123 53.266C999.946 53.266 1003.04 49.8249 1003.04 45.5707V29.3731C1003.04 25.1249 999.94 21.6838 996.123 21.6838C992.305 21.6838 989.198 25.1249 989.198 29.3731V45.5707Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.47 53.3266H1016.95V36.6374C1016.95 36.6374 1016.27 30.6232 1022.77 29.8525C1026.79 30.2409 1028.89 31.7763 1028.71 37.7419C1028.71 42.9368 1028.71 53.3266 1028.71 53.3266H1038.17V34.0642C1038.17 34.0642 1038.26 23.8686 1028.5 22.139C1026.4 21.7566 1020.46 21.7567 1017.02 26.5632V22.315H1007.47V53.3266Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip95_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M554.51 13.0245C568.396 26.9098 568.4 49.4155 554.523 63.2924C540.646 77.1693 518.141 77.1648 504.255 63.2795C490.37 49.3942 490.366 26.8886 504.242 13.0117C518.119 -0.865213 540.625 -0.860742 554.51 13.0245Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.275 29.276C509.28 29.8212 509.446 30.3527 509.753 30.8032C510.06 31.2537 510.494 31.603 511 31.8069C511.505 32.0108 512.06 32.0601 512.594 31.9486C513.127 31.8371 513.616 31.5697 513.998 31.1804C514.379 30.7911 514.637 30.2973 514.738 29.7616C514.839 29.2258 514.778 28.6722 514.564 28.1707C514.351 27.6692 513.993 27.2425 513.536 26.9444C513.08 26.6464 512.545 26.4905 512 26.4965C511.27 26.5045 510.573 26.8017 510.063 27.3228C509.552 27.8439 509.268 28.5463 509.275 29.276Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.966 45.5707C504.966 49.8189 508.067 53.266 511.891 53.266C515.714 53.266 518.809 49.8249 518.809 45.5707V29.3731C518.809 25.1249 515.708 21.6838 511.891 21.6838C508.073 21.6838 504.966 25.1249 504.966 29.3731V45.5707Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.233 53.3266H532.719V36.6374C532.719 36.6374 532.033 30.6232 538.539 29.8525C542.562 30.2409 544.662 31.7763 544.474 37.7419C544.474 42.9368 544.474 53.3266 544.474 53.3266H553.941V34.0642C553.941 34.0642 554.032 23.8686 544.268 22.139C542.168 21.7566 536.233 21.7567 532.792 26.5632V22.315H523.233V53.3266Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip96_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1329.28 13.0245C1343.17 26.9098 1343.17 49.4155 1329.29 63.2924C1315.42 77.1693 1292.91 77.1648 1279.03 63.2795C1265.14 49.3942 1265.14 26.8886 1279.01 13.0117C1292.89 -0.865213 1315.4 -0.860742 1329.28 13.0245Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1284.05 29.276C1284.05 29.8212 1284.22 30.3527 1284.52 30.8032C1284.83 31.2537 1285.27 31.603 1285.77 31.8069C1286.28 32.0108 1286.83 32.0601 1287.37 31.9486C1287.9 31.8371 1288.39 31.5697 1288.77 31.1804C1289.15 30.7911 1289.41 30.2973 1289.51 29.7616C1289.61 29.2258 1289.55 28.6722 1289.34 28.1707C1289.12 27.6692 1288.76 27.2425 1288.31 26.9444C1287.85 26.6464 1287.32 26.4905 1286.77 26.4965C1286.04 26.5045 1285.34 26.8017 1284.83 27.3228C1284.32 27.8439 1284.04 28.5463 1284.05 29.276Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.74 45.5707C1279.74 49.8189 1282.84 53.266 1286.66 53.266C1290.49 53.266 1293.58 49.8249 1293.58 45.5707V29.3731C1293.58 25.1249 1290.48 21.6838 1286.66 21.6838C1282.84 21.6838 1279.74 25.1249 1279.74 29.3731V45.5707Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298 53.3266H1307.49V36.6374C1307.49 36.6374 1306.8 30.6232 1313.31 29.8525C1317.33 30.2409 1319.43 31.7763 1319.25 37.7419C1319.25 42.9368 1319.25 53.3266 1319.25 53.3266H1328.71V34.0642C1328.71 34.0642 1328.8 23.8686 1319.04 22.139C1316.94 21.7566 1311 21.7567 1307.56 26.5632V22.315H1298V53.3266Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip97_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.664 13.0245C471.549 26.9098 471.553 49.4155 457.676 63.2924C443.8 77.1693 421.294 77.1648 407.409 63.2795C393.523 49.3942 393.519 26.8886 407.396 13.0117C421.273 -0.865213 443.778 -0.860742 457.664 13.0245Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.428 29.276C412.433 29.8212 412.6 30.3527 412.907 30.8032C413.214 31.2537 413.647 31.603 414.153 31.8069C414.659 32.0108 415.213 32.0601 415.747 31.9486C416.281 31.8371 416.769 31.5697 417.151 31.1804C417.532 30.7911 417.79 30.2973 417.891 29.7616C417.992 29.2258 417.932 28.6722 417.718 28.1707C417.504 27.6692 417.146 27.2425 416.689 26.9444C416.233 26.6464 415.698 26.4905 415.153 26.4965C414.423 26.5045 413.727 26.8017 413.216 27.3228C412.705 27.8439 412.422 28.5463 412.428 29.276Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.119 45.5707C408.119 49.8189 411.22 53.266 415.044 53.266C418.867 53.266 421.962 49.8249 421.962 45.5707V29.3731C421.962 25.1249 418.861 21.6838 415.044 21.6838C411.227 21.6838 408.119 25.1249 408.119 29.3731V45.5707Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.387 53.3266H435.872V36.6374C435.872 36.6374 435.186 30.6232 441.692 29.8525C445.716 30.2409 447.816 31.7763 447.627 37.7419C447.627 42.9368 447.627 53.3266 447.627 53.3266H457.095V34.0642C457.095 34.0642 457.186 23.8686 447.421 22.139C445.321 21.7566 439.386 21.7567 435.945 26.5632V22.315H426.387V53.3266Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip98_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M748.203 547.147C762.088 561.033 762.093 583.538 748.216 597.415C734.339 611.292 711.833 611.288 697.948 597.402C684.063 583.517 684.058 561.011 697.935 547.134C711.812 533.258 734.318 533.262 748.203 547.147Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.968 563.399C702.972 563.944 703.139 564.475 703.446 564.926C703.753 565.376 704.187 565.726 704.692 565.93C705.198 566.134 705.753 566.183 706.286 566.071C706.82 565.96 707.309 565.692 707.69 565.303C708.072 564.914 708.33 564.42 708.43 563.884C708.531 563.349 708.471 562.795 708.257 562.293C708.043 561.792 707.685 561.365 707.229 561.067C706.772 560.769 706.238 560.613 705.693 560.619C704.963 560.627 704.266 560.924 703.755 561.446C703.244 561.967 702.961 562.669 702.968 563.399Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.659 579.694C698.659 583.942 701.76 587.389 705.583 587.389C709.407 587.389 712.502 583.948 712.502 579.694V563.496C712.502 559.248 709.401 555.807 705.583 555.807C701.766 555.807 698.659 559.248 698.659 563.496V579.694Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.926 587.45H726.412V570.76C726.412 570.76 725.726 564.746 732.231 563.975C736.255 564.364 738.355 565.899 738.167 571.865C738.167 577.06 738.167 587.45 738.167 587.45H747.634V568.187C747.634 568.187 747.725 557.991 737.96 556.262C735.861 555.88 729.925 555.88 726.484 560.686V556.438H716.926V587.45Z",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip99_131_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.889 474.378C121.894 474.923 122.06 475.455 122.367 475.905C122.674 476.356 123.108 476.705 123.614 476.909C124.119 477.113 124.674 477.162 125.208 477.051C125.741 476.939 126.23 476.672 126.612 476.283C126.993 475.893 127.251 475.4 127.352 474.864C127.453 474.328 127.392 473.774 127.179 473.273C126.965 472.771 126.607 472.345 126.15 472.047C125.694 471.749 125.159 471.593 124.614 471.599C123.884 471.607 123.188 471.904 122.677 472.425C122.166 472.946 121.883 473.649 121.889 474.378Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.551 509.809C183.21 495.15 183.204 471.378 168.539 456.713C153.873 442.047 130.101 442.041 115.442 456.7C100.784 471.358 100.789 495.13 115.455 509.796C130.121 524.462 153.893 524.467 168.551 509.809ZM117.58 490.673C117.58 494.921 120.681 498.368 124.505 498.368C128.328 498.368 131.423 494.927 131.423 490.673V474.475C131.423 470.227 128.322 466.786 124.505 466.786C120.687 466.786 117.58 470.227 117.58 474.475V490.673ZM145.333 498.429H135.847V467.417H145.406V471.666C148.847 466.859 154.782 466.859 156.882 467.241C166.647 468.971 166.556 479.167 166.556 479.167V498.429H157.088V482.844C157.276 476.879 155.177 475.343 151.153 474.955C144.647 475.726 145.333 481.74 145.333 481.74V498.429Z",
    fill: "#C4C4C4"
  })))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_131_104)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.3877,
    y: -16.0912,
    width: 1562.54,
    height: 820.649,
    fill: "url(#paint0_linear_131_104)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    width: 1440,
    height: 695,
    fill: "url(#paint1_linear_131_104)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1439,
    height: 694,
    stroke: "#8E54E9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_131_104",
    x1: 10.3877,
    y1: -16.0912,
    x2: 1604.26,
    y2: 804.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01E69C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507015,
    stopColor: "#51AED6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E54E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_131_104",
    x1: 1393.5,
    y1: 84.5001,
    x2: -57.5,
    y2: 726.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.182292,
    stopColor: "#151313",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#1C1919",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#1E1C1E",
    stopOpacity: 0.928801
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#201E22",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915844,
    stopColor: "#231F20",
    stopOpacity: 0.24
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 695,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(588.079 534.123)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(878.618 267.061)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(588.079 623.143)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(975.464 178.041)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(684.925 267.061)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(491.232 445.102)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(491.232 178.041)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(297.539 89.0204)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(297.539)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(394.386 445.102)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(7 356.082)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(200.693)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(1072.31 356.082)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(1169.16 178.041)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(878.618 178.041)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(781.772 267.061)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(781.772 178.041)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(200.693 267.061)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(878.618 445.102)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(975.464 356.082)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(1072.31 89.0204)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip22_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(588.079 89.0204)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip23_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(491.232 89.0204)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip24_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(7 178.041)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip25_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(103.846 89.0204)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip26_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(491.232 534.123)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip27_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(1169.16)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip28_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(878.618)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip29_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(781.772)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip30_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(200.693 89.0204)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip31_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(297.539 356.082)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip32_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(1072.31)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip33_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(684.925)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip34_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(1362.85)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip35_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(588.079)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip36_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip37_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(103.846)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip38_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(297.539 178.041)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip39_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(684.925 445.102)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip40_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(1169.16 445.102)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip41_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(1266 178.041)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip42_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(200.693 356.082)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip43_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(878.618 534.123)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip44_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(684.925 356.082)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip45_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(394.386 534.123)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip46_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(1362.85 267.061)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip47_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(394.386 356.082)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip48_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(588.079 445.102)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip49_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(1072.31 445.102)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip50_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(1169.16 267.061)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip51_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(588.079 356.082)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip52_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(1266 356.082)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip53_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(878.618 356.082)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip54_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(103.846 356.082)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip55_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(878.618 623.143)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip56_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(975.464 445.102)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip57_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(1072.31 178.041)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip58_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(684.925 178.041)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip59_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(588.079 178.041)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip60_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(7 267.061)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip61_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(103.846 178.041)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip62_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(491.232 623.143)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip63_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(1169.16 89.0204)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip64_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(878.618 89.0204)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip65_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(684.925 89.0204)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip66_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(781.772 89.0204)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip67_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(200.693 178.041)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip68_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(297.539 534.123)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip69_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(394.386 623.143)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip70_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(684.925 623.143)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip71_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(7 89.0204)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip72_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(975.464 534.123)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip73_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(1072.31 267.061)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip74_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(491.232 356.082)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip75_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(588.079 267.061)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip76_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(1362.85 356.082)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip77_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(103.846 267.061)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip78_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(297.539 623.143)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip79_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(975.464 267.061)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip80_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(491.232 267.061)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip81_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(1362.85 178.041)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip82_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(394.386 267.061)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip83_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(1266 267.061)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip84_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(103.846 623.143)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip85_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(1169.16 356.082)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip86_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(297.539 445.102)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip87_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(975.464 89.0204)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip88_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(394.386 89.0204)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip89_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(1362.85 89.0204)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip90_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(394.386 178.041)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip91_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(1266 89.0204)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip92_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(103.846 534.123)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip93_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(297.539 267.061)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip94_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(975.464)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip95_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(491.232)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip96_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(1266)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip97_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(394.386)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip98_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(684.925 534.123)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip99_131_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3033,
    height: 76.3033,
    fill: "white",
    transform: "translate(103.846 445.102)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBackground);
export default __webpack_public_path__ + "static/media/login_background.fff55c4b64c77fff4ca0cc1e7aed8161.svg";
export { ForwardRef as ReactComponent };